const es = {
  FEBRUARY: 'FEBRERO',
  JANUARY: 'ENERO',
  JULY: 'JULIO',
  JUNE: 'JUNIO',
  MARCH: 'MARZO',
  Pin_External: 'Pin externo',
  Pin_Internal: 'Pin interno',
  accountNotVerriyed: 'Cuenta no verificada',
  accountNotYetActivated: 'Su cuenta aún no ha sido activada',
  assistance_as_needed: 'Asistencia',
  automatic: 'Automático',
  backward: 'Atrás',
  block: 'Bloquear edición',
  allDevices: 'Todos los dispositivos',
  selectPeriod: 'Mostrar datos de',
  lastMonthFilter: 'Último mes',
  totalSteps: 'Pasos totales',
  rankingStepsByUser: 'Ranking pasos por usuario',
  unknownUser: 'Usuario Desconocido',
  unknownOrg: 'Organización Desconocida',
  checkEmail:
    'Por favor, pongase en contacto con su administrador para activar su cuenta.',
  clear: 'Limpiar',
  close: 'Cerrar',
  dashboard: 'Panel principal',
  days: 'días',
  dateRange: 'Selecciona un rango de fechas',
  deleteDevice: 'Eliminar dispositivo',
  deleteInstitution: 'Eliminar organización',
  deletePatient: 'Eliminar paciente',
  deleteUser: 'Eliminar usuario',
  doPremium: 'Hazte Premium',
  doPremiumDescription:
    'Para acceder a esta funcionalidad debes ser usuario premium.',
  edit: 'Habilitar edición',
  emptyAlarms: 'Este dispositivo no ha registrado alarmas',
  emptyMessage: 'No hay datos para mostrar',
  emptyValuesTable: 'No hay valores para mostrar...',
  errorForms: 'Existen errores en el formulario',
  forward: 'Adelante',
  goBack: 'Volver atrás',
  loading: 'Cargando...',
  noResults: 'Sin resultados',
  validations: {
    required: 'Campo obligatorio',
  },
  goHome: 'Ir a inicio',
  institution: 'Organización',
  intention: 'Activación por fuerza',
  july: 'Julio',
  june: 'Junio',
  messages: {
    confirm: 'Confirmar',
    cant_use_device: 'No puedes hacer uso de este dispositivo',
    changing_password: 'Cambiando contraseña, por favor espera...',
    contact:
      'Por favor, vuelve a intentar más tarde. Si el problema persiste, contacta con ',
    dashboards: {
      create_dashboard: 'Dashboard creado correctamente',
      dashboard_created_error: 'Error al crear el dashboard',
    },
    surveys: {
      create_survey: 'Encuesta creada correctamente',
      survey_created_error: 'Error al crear la encuesta',
      survey_paused_success: 'Encuesta pausada correctamente',
      survey_paused_error: 'Error al pausar la encuesta',
      survey_resumed_success: 'Encuesta reanudada correctamente',
      survey_resumed_error: 'Error al reanudar la encuesta',
      survey_sended_success: 'Encuesta enviada correctamente',
      survey_sended_error: 'Error al enviar la encuesta',
      recipients_added_success: 'Destinatarios añadidos correctamente',
      recipients_added_error: 'Error al añadir los destinatarios',
      recipients_deleted_success: 'Destinatarios eliminados correctamente',
      recipients_deleted_error: 'Error al eliminar los destinatarios',
      draft_saved_success: 'Borrador guardado correctamente',
      draft_saved_error: 'No se pudo guardar el borrador. Inténtalo de nuevo.',
      draft_load_error: 'No se pudo cargar el borrador.',
      draft_deleted_error:
        'No se pudo eliminar el borrador. Inténtalo de nuevo.',
    },
    devices: {
      confirm_delete_device: '¿Seguro que quieres borrar el dispositivo',
      add_device_to_org_error:
        'Error al añadir el dispositivo a la organización',
      add_device_to_org_success: 'Dispositivo añadido a la organización',
      create_device: 'Dispositivo creado correctamente',
      delete_device_error: 'Error al eliminar el dispositivo',
      delete_device_from_org_error:
        'Error al eliminar el dispositivo de la organización, hay usuarios que dependen de ella contacte con el soporte para relaizar la accion',
      delete_device_from_org_success:
        'Dispositivo eliminado de la organización',
      delete_device_success: 'Dispositivo eliminado correctamente',
      device_created_error: 'Error al crear el dispositivo',
      device_not_exists: 'No existe este dispositivo',
      device_updated_error: 'Error al actualizar el dispositivo',
      unique_serial_error: 'El número de serie ya está en uso',
      update_device: 'Dispositivo actualizado correctamente',
    },
    email_already_in_use: 'Email ya en uso',
    error: 'Error',
    error_ingestion: 'Error al procesar la ingesta, la ingesta esta corrupta',
    error_message: 'Algo salió mal',
    incidence: {
      create: 'Incidencia creada correctamente',
      create_error: 'Error al crear la incidencia',
      close: 'Incidencia cerrada correctamente',
      close_error: 'Error al cerrar la incidencia',
    },
    info: 'Info',
    loading: 'Cargando',
    ingestion: {
      dowload_multiple_files_error: 'Error al descargar varios archivos',
      dowload_multiple_files_success: 'Archivos descargados correctamente',
      download_multiple_files: 'Descargando varios archivos',
      empty_file: 'Archivo vacío',
      error_downloading: 'Error al descargar el archivo',
      success_donwload: 'Archivo descargado correctamente',
      payload_too_large:
        'Archivo demasiado grande. Contacta con soporte para más información.',
    },
    invalidDate: 'Fecha no válida',
    login: {
      error: 'Usuario y/o contraseña incorrectos',
      ip_blocked:
        'Demasiados intentos fallidos desde esta IP. Por favor, intentalo de nuevo en los siguientes minutos: ',
      account_permanent_block:
        'Usuario bloqueado de forma permanente. Por favor contacta con los administradores',
      account_blocked:
        'Tu cuenta ha sido bloqueada debido a demasiados intentos fallidos. Por favor, inténtalo de nuevo en los siguientes minutos: ',
      account_pending: 'Tu cuenta está pendiente de verificación',
      account_not_active:
        'Tu cuenta está pendiente de activación por parte del administrador de la organización',
      unexpected_error: 'Error inesperado durante el proceso de Login',
    },
    o_id_not_found: 'Código de dispositivo no encontrado',
    maintenance_orders: {
      create: 'Orden de mantenimiento creada correctamente',
      create_error: 'Error al crear la orden de mantenimiento',
      assign_error: 'Error al asignar la orden de mantenimiento',
    },
    org: {
      add_device_error: 'Error al añadir el dispositivo a la organización',
      create_org: 'Organización creada correctamente',
      create_org_error: 'Error al crear la organización',
      delete_org: 'Organización eliminada correctamente',
      delete_org_error: 'Error al eliminar la organización',
      error_fetching_org_data: 'Error al obtener los datos de la organización',
      premium_error: 'Error al actualizar el estado premium',
      premium_success: 'Estado premium actualizado correctamente',
      update_org: 'Organización actualizada correctamente',
      update_org_error: 'Error al actualizar la organización',
      update_creator_success: 'Creador actualizado correctamente',
      update_creator_error: 'Error al actualizar creador',
    },
    patient: 'Paciente',
    patient_modified_error: 'Error al modificar el paciente',
    patient_modified_success: 'Paciente modificado',
    report: {
      downloading: 'Por favor, espere mientras se descarga el archivo...',
      success: 'Informe generado correctamente',
    },
    success: 'Éxito',
    success_message: 'Operación realizada con éxito',
    update_share_error: 'Error al actualizar los datos',
    update_share_success: 'Datos actualizados correctamente',
    user: {
      active_error: 'Error al activar el usuario',
      user_created_error: 'Error al crear el usuario',
      user_created_success: 'Usuario creado correctamente',
      user_updated_error: 'Error al actualizar el usuario',
      user_updated_success: 'Usuario actualizado correctamente',
    },
    warning: 'Advertencia',
    authentication_required: 'Autenticación requerida',
    access_denied:
      'Acceso denegado. Solo usuarios con rol de mantenimiento pueden acceder.',
    access_denied_admin:
      'Acceso denegado. Solo usuarios con rol admin pueden acceder.',
    error_uploading_firmware: 'Error al cargar el firmware',
    registerSuccess:
      'Usuario registrado correctamente. Por favor revisa tu correo y verifica tu cuenta.',
  },
  my_profile: {
    copy: 'Copiar',
    copied: 'Copiado',
    blockOrganizationData:
      '¿Quieres dejar de compartir los datos de tu organización?',
    blockPersonalData: '¿Quieres dejar de compartir tus datos personales?',
    changePassword: 'Cambiar contraseña',
    confirmOrganizationTitle:
      'Cambios en la privacidad de los datos de tu organización',
    confirmPassword: 'Confirma tu nueva contraseña: ',
    confirmPersonalTitle: 'Cambios en la privacidad de tus datos personales',
    confirmchangepassword: 'Cambio de contraseña efectuado correctamente',
    disablePrivacyField: '¿Quieres desactivar esta opción de privacidad?',
    enablePrivacyField: '¿Quieres activar esta opción de privacidad?',
    errorchangepassword: 'No se ha podido efectuar el cambio de contraseña',
    hide: 'Ocultar',
    incorrectpassword: 'Contraseña incorrecta',
    nationality: {
      afghan: 'Afgana',
      argentine: 'Argentina',
      australian: 'Australiana',
      austrian: 'Austriaca',
      brazilian: 'Brasileña',
      british: 'Británica',
      canadian: 'Canadiense',
      chilean: 'Chilena',
      chinese: 'China',
      colombian: 'Colombiana',
      cuban: 'Cubana',
      danish: 'Danesa',
      dutch: 'Neerlandesa',
      egyptian: 'Egipcia',
      english: 'Inglesa',
      filipino: 'Filipina',
      finnish: 'Finlandesa',
      french: 'Francesa',
      german: 'Alemana',
      greek: 'Griega',
      indian: 'India',
      irish: 'Irlandesa',
      italian: 'Italiana',
      japanese: 'Japonesa',
      korean: 'Coreana',
      mexican: 'Mexicana',
      moroccan: 'Marroquí',
      new_zealander: 'Neozelandesa',
      nigerian: 'Nigeriana',
      norwegian: 'Noruega',
      peruvian: 'Peruana',
      polish: 'Polaca',
      portuguese: 'Portuguesa',
      romanian: 'Rumana',
      russian: 'Rusa',
      saudi: 'Saudí',
      scottish: 'Escocesa',
      south_african: 'Sudafricana',
      spanish: 'Española',
      swedish: 'Sueca',
      swiss: 'Suiza',
      thai: 'Tailandesa',
      turkish: 'Turca',
      ukrainian: 'Ucraniana',
      uruguayan: 'Uruguaya',
      venezuelan: 'Venezolana',
      vietnamese: 'Vietnamita',
    },
    newPassword: 'Nueva contraseña:',
    oldPassword: 'Contraseña antigua:',
    organizationData: 'No compartir los datos de mi organización',
    passwordDifferentFromOld:
      'La nueva contraseña debe ser distinta de la actual.',
    personalData: 'No compartir mis datos personales',
    privacyDataTitle: 'Cambios en tus preferencias de privacidad',
    title: 'Mi cuenta',
    titlechangepassword: 'Cambio de contraseña ',
    unblockOrganizationData:
      '¿Quieres volver a compartir los datos de tu organización?',
    unblockPersonalData: '¿Quieres volver a compartir tus datos personales?',
    update_error: 'Error al actualizar la información',
    update_success: 'Datos actualizados',
  },
  no: 'No',
  noData: 'Sin datos',
  noSessionDevice: 'No hay sesiones para este dispositivo',
  numberOfSteps: 'Cantidad de pasos',
  optional: 'Opcional',
  pageNotFound: 'Página no encontrada',
  pageNotFoundDescription: 'La página que estás buscando no existe.',
  pages: {
    alarms: {
      active: 'Activo',
      alarms: {
        1: 'Test de calibración manual de articulaciones',
        2: 'Test de calibración automática de articulaciones',
        3: 'Test de calibración manual del motor de elevación',
        4: 'Test de calibración de la silla',
        5: 'Test funcional completo',
        6: 'Test habilitar y deshabilitar alarmas',
        7: 'Test de calibración de la célula de carga',
        8: 'Test introducción manual de la calibración de cada motor',
        9: 'introducir manualmente la calibraciópn del sensor de 0',
        10: 'Test de calibración del IMU',
        11: 'Calibración automática del sensor de cero',
        501: 'Botón de parada de emergencia pulsado',
        502: 'No data',
        503: 'El nivel de carga de la batería principal es bajo',
        504: 'El nivel de carga de la batería principal es críticamente bajo',
        505: 'La temperatura de la batería principal es críticamente alta',
        506: 'No data',
        507: "La postura del dispositivo es diferente de 'Sentado' o 'De pie'",
        508: 'Se perdió la comunicación entre PCS y SCS',
        509: 'Se perdió la comunicación entre EPOS 1 y PCS',
        510: 'Se perdió la comunicación entre EPOS 2 y PCS',
        511: 'Se perdió la comunicación entre EPOS 3 y PCS',
        512: 'Se perdió la comunicación entre EPOS 4 y PCS',
        513: 'No data',
        514: 'No data',
        515: 'Señal fault activada en EPOS 1',
        516: 'Señal fault activada en EPOS 2',
        517: 'Señal fault activada en EPOS 3',
        518: 'Señal fault activada en EPOS 4',
        519: 'No data',
        520: 'No data',
        521: 'No data',
        522: 'No data',
        523: 'Error en el controlador de motor 1 (CI)',
        524: 'Error en el controlador de motor 2 (CD)',
        525: 'Error en el controlador de motor 3 (RI)',
        526: 'Error en el controlador de motor 4 (RD)',
        527: 'No data',
        528: 'No data',
        529: 'No data',
        530: 'No data',
        531: 'Temperatura excesiva en EPOS 1 (CI)',
        532: 'Temperatura excesiva en EPOS 2 (CD)',
        533: 'Temperatura excesiva en EPOS 3 (RI)',
        534: 'Temperatura excesiva en EPOS 4 (RD)',
        535: 'Temperatura excesiva en el motor 1 (CI)',
        536: 'Temperatura excesiva en el motor 2 (CD)',
        537: 'Temperatura excesiva en el motor 3 (RI)',
        538: 'Temperatura excesiva en el motor 4 (RD)',
        539: 'Consumo excesivo de corriente en el motor 1 (CI)',
        540: 'Consumo excesivo de corriente en el motor 2 (CD)',
        541: 'Consumo excesivo de corriente en el motor 3 (RI)',
        542: 'Consumo excesivo de corriente en el motor 4 (RD)',
        543: 'No data',
        544: 'No data',
        545: 'No data',
        546: 'No data',
        547: 'Par excesivo medido en el motor 1 (CI)',
        548: 'Par excesivo medido en el motor 2 (CD)',
        549: 'Par excesivo medido en el motor 3 (RI)',
        550: 'Par excesivo medido en el motor 4 (RD)',
        551: 'No data',
        552: 'No data',
        553: 'No data',
        554: 'No data',
        555: 'Desajuste entre la referencia y el sensor 1 en el motor 1 (CI)',
        556: 'Desajuste entre la referencia y el sensor 1 en el motor 2 (CD)',
        557: 'Desajuste entre la referencia y el sensor 1 en el motor 3 (RI)',
        558: 'Desajuste entre la referencia y el sensor 1 en el motor 4 (RD)',
        559: 'Posición erronea en el sensor Orbis en el motor 1 (CI)',
        560: 'Posición erronea en el sensor Orbis en el motor 2 (CD)',
        561: 'Posición erronea en el sensor Orbis en el motor 3 (RI)',
        562: 'Posición erronea en el sensor Orbis en el motor 4 (RD)',
        563: 'Se perdió la comunicación entre el dispositivo y la aplicación',
        564: 'La posición de la silla es incorrecta en el movimiento de sentarse/levantarse',
        565: 'La altura del motor de elevación es mayor que la altura máxima',
        566: 'La altura del motor de elevación es inferior a la altura mínima',
        567: 'El motor de elevación se está moviendo cuando está deshabilitado o se está moviendo en la dirección incorrecta',
        568: 'El exo no sigue los ángulos objetivo en el movimiento de sentarse',
        569: 'La temperatura del procesador es demasiado alta',
        570: 'Vrefint demasiado bajo',
        571: 'Vrefint demasiado alto',
        572: 'La temperatura de la caja electrónica es demasiado alta',
        573: 'No se detecta la tarjeta de potencia PEB',
        574: 'No se detecta que el exoesqueleto esté conectado al andador',
        575: 'La señal de interlock del andador es baja',
        576: 'La señal de interlock de las ruedas es baja',
        577: 'Pwrgood_24v es bajo',
        578: 'Pwrgood_5v es bajo',
        579: 'La señal Pwrgood_exo es baja cuando el exo está habilitado',
        580: 'La señal Pwrgood_wf es baja cuando el andador está habilitado',
        581: 'La señal de Pwrgood_wheels es baja cuando las ruedas están habilitadas',
        582: 'La señal Pwrgood_exo es alta antes de habilitar exo',
        583: 'La señal Pwrgood_wf es alta antes de habilitar el andador',
        584: 'La señal Pwrgood_wheels es alta antes de habilitar las ruedas',
        585: 'Referencia fuera de límites SW en el motor 1 (CI)',
        586: 'Referencia fuera de límites SW en el motor 2 (CD)',
        587: 'Referencia fuera de límites SW en el motor 3 (RI)',
        588: 'Referencia fuera de límites SW en el motor 4 (RD)',
        589: 'Posición sensor Mille fuera de los límites del software en el motor 1 (CI)',
        590: 'Posición sensor Mille fuera de los límites del software en el motor 2 (CD)',
        591: 'Posición sensor Mille fuera de los límites del software en el motor 3 (RI)',
        592: 'Posición sensor Mille fuera de los límites del software en el motor 4 (RD)',
        593: 'Exceso de recorrido en posición en el motor 1 (CI)',
        594: 'Exceso de recorrido en posición en el motor 2 (CD)',
        595: 'Exceso de recorrido en posición en el motor 3 (RI)',
        596: 'Exceso de recorrido en posición en el motor 4 (RD)',
        597: 'Motor de elevación fuera de posición para movimiento',
        598: 'Parámetros del paciente no válidos',
        599: 'Error en inicialización de EPOS',
        600: 'Lectura incorrecta del sensor de altura',
        601: 'El sensor de altura o el motor de elevación no funcionan',
        602: 'Se intenta pasar del modo de pie a silla de ruedas o del modo silla de ruedas a de pie',
        603: 'El StatusWord de la EPOS 1 (CI) no coincide con el estado de motores activos',
        604: 'El StatusWord de la EPOS 2 (CD) no coincide con el estado de motores activos',
        605: 'El StatusWord de la EPOS 3 (RI) no coincide con el estado de motores activos',
        606: 'El StatusWord de la EPOS 4 (RD) no coincide con el estado de motores activos',
        607: 'Se está detectando un bloqueo en las caderas',
        608: 'Se está detectando un bloqueo en el asiento',
        609: 'Se está detectando movimiento en las caderas',
        610: 'Se está detectando movimiento en el asiento',
        611: 'Se ha perdido la comunicación con el sistema de gestion de bateria',
        612: 'Presión peligrosa detectada en el suelo',
        613: 'Desajuste de posición entre el sensor 1 y el sensor 2 en el motor 1 (CI)',
        614: 'Desajuste de posición entre el sensor 1 y el sensor 2 en el motor 2 (CD)',
        615: 'Desajuste de posición entre el sensor 1 y el sensor 2 en el motor 3 (RI)',
        616: 'Desajuste de posición entre el sensor 1 y el sensor 2 en el motor 4 (RD)',
        617: 'Modo de operación en la EPOS 1 no es el esperado',
        618: 'Modo de operación en la EPOS 2 no es el esperado',
        619: 'Modo de operación en la EPOS 3 no es el esperado',
        620: 'Modo de operación en la EPOS 4 no es el esperado',
        621: 'Motor 1 no esta disponible para moverse al entrar a un estado que lo requiere',
        622: 'Motor 2 no esta disponible para moverse al entrar a un estado que lo requiere',
        623: 'Motor 3 no esta disponible para moverse al entrar a un estado que lo requiere',
        624: 'Motor 4 no esta disponible para moverse al entrar a un estado que lo requiere',
        625: 'La versión de MCS no es igual en todas las EPOS',
        626: 'La silla esta desplegada mientras se esta caminando',
        627: 'El offset del sensor de zero es superior al limite',
        628: 'Se ha superado el numero de pasos permitidos para calibrar el sensor de zero',
        629: 'El angulo de la silla es superior al limite',


      },
      alarmsAtlas: {
        501: 'Botón de parada de emergencia pulsado.',
        502: 'Se detectó un error en la memoria flash',
        503: 'El nivel de carga de la batería principal es bajo',
        504: 'El nivel de carga de la batería principal es críticamente bajo.',
        505: 'La temperatura de la batería principal es críticamente alta.',
        506: 'La batería auxiliar está críticamente baja',
        507: "La postura del dispositivo es diferente de 'Sentado' o 'De pie'. Si va a caminar, las piernas deben estar estiradas con ángulos aproximados a 0º. Si está sentado las piernas deben de estar formando aproximadamente un ángulo de 90º",
        508: 'Se perdió la comunicación entre la SCB  y la MPB.',
        509: 'Se perdió la comunicación entre MCB 1 y MPB.',
        510: 'Se perdió la comunicación entre MCB 2 y MPB',
        511: 'Se perdió la comunicación entre MCB 3 y MPB',
        512: 'Se perdió la comunicación entre MCB 4 y MPB.',
        513: 'Se perdió la comunicación entre MCB 5 y MPB',
        514: 'Se perdió la comunicación entre MCB 6 y MPB',
        515: 'Error durante el autotest en placa electrónica MCB 1.',
        516: 'Error durante el autotest en placa electrónica MCB 2.',
        517: 'Error durante el autotest en placa electrónica MCB 3.',
        518: 'Error durante el autotest en placa electrónica MCB 4.',
        519: 'Error durante el autotest en placa electrónica MCB 5.',
        520: 'Error durante el autotest en placa electrónica MCB 6.',
        521: 'Fallo de variable de clase B en MPB',
        522: 'No todas las MCB están listas',
        523: 'Error placa controladora de motor 1 (ABD I).Se debe apagar y encender el dispositivo.',
        524: 'Error placa controladora de motor 2 (CI).Se debe apagar y encender el dispositivo',
        525: 'Error placa controladora de motor 3 (RI). Se debe apagar y encender el dispositivo.',
        526: 'Error placa controladora de motor 4 (TI). Se debe apagar y encender el dispositivo.',
        527: 'Error placa controladora de motor 5 (ABD D). Se debe apagar y encender el dispositivo.',
        528: 'Error placa controladora de motor 6 (CD). Se debe apagar y encender el dispositivo.',
        529: 'Error placa controladora de motor 7 (RD). Se debe apagar y encender el dispositivo.',
        530: 'Error placa controladora de motor 8 (TD). Se debe apagar y encender el dispositivo.',
        531: 'Temperatura excesiva en motor 1 (ABD I). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        532: 'Temperatura excesiva en motor 2 (CI). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        533: 'Temperatura excesiva en motor 3 (RI). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        534: 'Temperatura excesiva en motor 4 (TI). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        535: 'Temperatura excesiva en motor 5 (ABD D). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        536: 'Temperatura excesiva en motor 6 (CD). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        537: 'Temperatura excesiva en motor 7 (RD). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        538: 'Temperatura excesiva en motor 8 (TD). Se debe apagar el dispositivo y dejar refrigerar antes de volver a usar.',
        539: 'Consumo excesivo de corriente en motor 1 (ABD I).',
        540: 'Consumo excesivo de corriente en motor 2 (CD).',
        541: 'Consumo excesivo de corriente en motor 3 (RI).',
        542: 'Consumo excesivo de corriente en motor 4 (TI).',
        543: 'Consumo excesivo de corriente en motor 5 (ABD D).',
        544: 'Consumo excesivo de corriente en motor 6 (CD).',
        545: 'Consumo excesivo de corriente en motor 7 (RD).',
        546: 'Consumo excesivo de corriente en motor 8 (TD).',
        547: 'Par excesivo medido en el motor 1 (ABD I).',
        548: 'Par excesivo medido en el motor 2 (CI).',
        549: 'Par excesivo medido en el motor 3 (RI).',
        550: 'Par excesivo medido en el motor 4 (TI).',
        551: 'Par excesivo medido en el motor 5 (ABD D).',
        552: 'Par excesivo medido en el motor 6 (CD).',
        553: 'Par excesivo medido en el motor 7 (RD).',
        554: 'Par excesivo medido en el motor 8 (TD).',
        555: 'Desajuste entre sensor Hall y sensor absoluto en motor 1 (ABD I).',
        556: 'Desajuste entre sensor Hall y sensor absoluto en motor 2 (CI).',
        557: 'Desajuste entre sensor Hall y sensor absoluto en motor 3 (RI).',
        558: 'Desajuste entre sensor Hall y sensor absoluto en motor 4 (TI).',
        559: 'Desajuste entre sensor Hall y sensor absoluto en motor 5 (ABD D).',
        560: 'Desajuste entre sensor Hall y sensor absoluto en motor 6 (CD).',
        561: 'Desajuste entre sensor Hall y sensor absoluto en motor 7 (RD).',
        562: 'Desajuste entre sensor Hall y sensor absoluto en motor 8 (TD).',
        563: 'Se perdió la comunicación entre el dispositivo y la aplicación',
      },
      date: 'Fecha y hora',
      details: 'Detalles',
      eventId: 'Id de evento',
      eventType: 'Tipo de evento',
      inProgress: 'En proceso',
      inactive: 'Inactivo',
      ingest: 'Ingesta de datos',
      message: 'Mensaje',
      noAlarms: 'No hay alarmas disponibles',
      noParams: 'Sin parámetros',
      params: 'Parámetros',
      pending: 'Pendiente',
      search: 'Buscar por codigo de alarma o tipo de alarma',
      solved: 'Solucionado',
      status: 'Estado',
      value: 'Valor',
      version: 'Versión',
    },
    verifyAccount: {
      pendingTitle: 'Verificando cuenta...',
      pendingDescription:
        'Estamos verificando tu cuenta, por favor espera unos segundos.',
      verifyButton: 'Verificar cuenta',
      activatedTitle: 'Cuenta verificada',
      verified: 'Tu cuenta ha sido verificada correctamente.',
      errorTitle: 'Error de verificación',
      error:
        'No hemos podido verificar tu cuenta. El enlace puede ser inválido o haber expirado.',
      alreadyActivated:
        'Ponte en contacto con el Admin de tu organización para que active tu cuenta.  ',
      backToLogin: 'Volver al inicio de sesión',
    },
    welcometemplate: {
      title: 'Ya puedes acceder a MarsiNet!',
      description:
        'Tu cuenta ha sido activada con éxito. Estamos encantados de tenerte con nosotros para transformar la rehabilitación mediante tecnología.',
      welcomeButton: 'Acceder a mi cuenta',
      errorSupport:
        'Si no has solicitado esta cuenta, por favor contacta con soporte.',
      welcomeSubject: '¡Bienvenido a la familia Marsinet!',
    },
    registerAccount: {
      registerTitle: '¡Cuenta registrada!',
      registerDescription:
        'Tu cuenta ha sido registrada correctamente. Ahora un administrador debe activarla para que puedas iniciar sesión. Revisa en tu buzón de Spam',
      backToLogin: 'Ir a Login',
      messageExpired:
        'El enlace ya fue utilizado o ha expirado. Si ya verificaste tu email, espera la activación del administrador.',
    },
    support: {
      confirmationTitle: 'Confirmación de solicitud de soporte',
      greeting: 'Hola {{name}},',
      confirmationMessage:
        'Hemos recibido correctamente tu solicitud de soporte. Nuestro equipo la revisará lo antes posible.',
      ticketId: 'ID de solicitud',
      issueType: 'Tipo de incidencia',
      messageLabel: 'Mensaje',
      viewRequestButton: 'Ver solicitud',
      responseInfo:
        'Te responderemos en cuanto revisemos la información enviada.',
      extraInfo:
        'Si necesitas añadir más detalles, puedes responder a este correo o contactar con nuestro equipo de soporte.',
      internalTitle: 'Nueva incidencia de soporte',
      internalHeading: 'Nueva solicitud de soporte recibida',
      internalDescription:
        'Se ha generado una nueva incidencia desde la plataforma.',
      userName: 'Nombre del usuario',
      userEmail: 'Correo del usuario',
      reserved: '© Marsi Bionics. Todos los derechos reservados.',
      footer: 'Este es un mensaje automático del sistema Marsinet.',
    },
    resetPassword: {
      title: 'Restablece tu contraseña',
      back: 'Volver al inicio de sesión',
      greeting: 'Hola {{name}},',
      description:
        'Hemos recibido una solicitud para restablecer la contraseña de tu cuenta. Pulsa en el botón inferior para continuar con el proceso.',
      button: 'Restablecer contraseña',
      note: 'Si no has solicitado este cambio, puedes ignorar este correo. Tu contraseña actual seguirá siendo válida mientras no completes el proceso.',
      footer: 'Este es un mensaje automático del sistema Marsinet.',
      password: 'Nueva contraseña',
      confirmPassword: 'Confirmar nueva contraseña',
      passwordChanged: 'Contraseña restablecida correctamente',
      errorChangingPassword: 'Error al restablecer la contraseña',
      reset: 'Restablecer contraseña',
      success: 'Contraseña restablecida correctamente',
      confirmPasswordMatch: 'Las contraseñas no coinciden',
    },
    admin: {
      pendingUsersTitle: 'Nuevos usuarios pendientes de activación',
      pendingUsersGreeting: 'Hola {{name}},',
      pendingUsersDescription:
        'Hay nuevos usuarios pendientes de activación en tu organización. Accede al panel de usuarios para revisarlos y activarlos si corresponde.',
      pendingUsersButton: 'Ir a usuarios pendientes',
      footer: 'Este es un mensaje automático del sistema Marsinet.',
    },
    devices: {
      activate: '¿Está seguro que desea activar el dispositivo?',
      activateHeader: 'Activar',
      activatesDevices: 'Dispositivos Activos',
      add: 'Añadir Dispositivo',
      app_version: 'Versión APP',
      battery_cycles: 'Ciclos de carga',
      ceb_version: 'Versión CEB',
      code: 'Código Dispositivo',
      codeInvalid: 'Código Organizacion no es válido',
      codeInvalidCharacters:
        'Código Dispositivo no puede contener caracteres especiales',
      codeRequired: 'Código Organizacion es requerido',
      desactivate: '¿Está seguro que desea desactivar el dispositivo?',
      desactivateHeader: 'Desactivar',
      desactivatesDevices: 'Dispositivos Inactivos',
      deviceNumber: 'Número de dispositivo',
      deviceNumberInvalid: 'Número de dispositivo no es válido',
      deviceNumberInvalidCharacters:
        'Número de dispositivo no puede contener caracteres especiales',
      devicePage: {
        institution: 'Añadir dispositivo a una organización',
        notEvents: 'No hay eventos para este dispositivo',
        notInstitution: 'No hay organización cliente para este dispositivo',
        serial: 'Nº serie',
        tabEvents: 'Eventos del Dispositivo',
        tabInfo: 'Información del Dispositivo',
        type: 'Tipo',
      },
      epos_version: 'Versión EPOS',
      esp_version: 'Versión ESP',
      mcb_version: 'Versión MCB',
      model: 'Modelo',
      modelInvadidCharacters: 'Modelo no puede contener caracteres especiales',
      modelInvalid: 'Modelo no es válido',
      modelInvalidCharacters: 'Modelo no puede contener caracteres especiales',
      modelRequired: 'Modelo es requerido',
      model_required: 'Modelo es requerido',
      mpb_version: 'Versión MPB',
      nameRequired: 'Nombre es requerido',
      num_serial: 'Número de serie',
      num_serial_required: 'Número de serie es requerido',
      o_id: 'ID Organización',
      o_id_invalid: 'ID Organización no es válido',
      o_id_invalid_characters:
        'ID Organización no puede contener caracteres especiales',
      o_id_required: 'ID Organización es requerido',
      optional_field: '(opcional)',
      organization: 'Organización',
      password: 'Contraseña',
      password_invalid: 'Contraseña no es válida',
      password_invalid_characters:
        'Contraseña no puede contener caracteres especiales',
      password_required: 'Contraseña es requerida',
      scb_version: 'Versión SCB',
      selectStatus: 'Selecciona un estado',
      serialInvalid: 'Número de serie no es válido',
      serialInvalidCharacters:
        'Número de serie no puede contener caracteres especiales',
      serialRequired: 'Número de serie es requerido',
      softwareVersion: 'Detalles del Sistema',
      structureInvalid: 'Versión no es válida',
      structureInvalidCharacters:
        'Versión no puede contener caracteres especiales',
      structureRequired: 'Versión es requerida',
      structure_version: 'Versión estructura',
      statusResponsible: 'Responsable del cambio',
      statusInfo: {
        created: {
          name: '0 - Creado',
          definition: 'Nº de serie planificado en producción.',
          responsible: 'Responsable de producción o sustituto',
        },
        producing: {
          name: '1.0 - En producción',
          definition: 'Dispositivo en línea de producción.',
          responsible: 'Responsable de producción o sustituto',
        },
        validation: {
          name: '1.1 - En validación',
          definition: 'Dispositivo pendiente de validación por calidad.',
          responsible: 'Responsable de producción o calidad',
        },
        packaging: {
          name: '1.2 - En packaging',
          definition: 'Dispositivo en proceso de embalado para su almacenamiento.',
          responsible: 'Personal de almacén o responsable de producción',
        },
        enabled: {
          name: '2 - Activo',
          definition: 'Dispositivo validado, almacenado y preparado para la venta.',
          responsible: 'Personal de almacén o responsable de producción',
        },
        pending_shipment: {
          name: '3.0 - Pendiente de envío',
          definition: 'Dispositivo asignado o reservado para su venta a cliente. Dispositivo pendiente de enviar tras mantenimiento.',
          responsible: 'Personal de almacén o responsable de producción',
        },
        picked_up: {
          name: '3.1 - Recogido',
          definition: 'Dispositivo recogido de nuestras instalaciones por distribuidor.',
          responsible: 'Personal de almacén o responsable de producción',
        },
        rented: {
          name: '4.0 - Alquilado',
        },
        purchased: {
          name: '4.1 - Comprado',
        },
        substitution: {
          name: '4.2 - Sustitución',
        },
        maintenance: {
          name: '5 - En mantenimiento',
        },
        disabled: {
          name: '6 - Inactivo',
        },
      },
      table: {
        actions: 'Acciones',
        active: 'Activo',
        device_state: 'Estado del dispositivo',
        id: 'Codigo dispositivo',
        model: 'Modelo',
        o_id: 'ID Organización',
        organization: 'Organización',
        serial: 'Nº serie',
        type: 'Tipo',
        org_distributor: 'Distribuidor',
        org_customer: 'Cliente',
        more_than_one: 'Varios clientes'
      },
      stateSuggestion: {
        title: 'Cambio de estado',
        currentState: 'Este dispositivo está en estado',
        question: '¿Quieres cambiar su estado?',
        doNothing: 'No hacer nada',
        save: 'Guardar cambio',
      },
      title: 'Listado dispositivos',
      total_device_steps: 'Total pasos',
      total_device_time: 'Tiempo total',
      type_device: 'Modelo de dispositivo',
      type_device_required: 'Modelo de dispositivo es requerido',
    },
    dashboards: {
      addDataSourceOrMetric: 'Añadir al dashboard',
      createDataSource: 'Crear Fuente de Datos',
      createMetric: 'Crear Métrica',
      name_required: 'Nombre del dashboard es requerido',
      title: 'Analíticas de datos',
      add: 'Crear Dashboard',
      edit: 'Editar Dashboard',
      cancelEdit: 'Cancelar cambios',
      addVisualization: 'Visualización',
      saveChanges: 'Guardar cambios',
      dataSources: 'Fuentes de Datos',
      back: 'Atrás',
      skip: 'Omitir',
      next: 'Siguiente',
      delete: {
        confirm_header: 'Borrar Dashboard',
        confirm_message: '¿Estás seguro de que quieres borrar "{{name}}"?',
        confirm_accept: 'Borrar',
        confirm_reject: 'Cancelar',
        success_summary: 'Borrada',
        success_detail: '"{{name}}" ha sido borrada correctamente.',
        error_summary: 'Error',
        error_detail: 'Borrado fallido, inténtalo de nuevo.',
      },
      visualization: {
        create: 'Crear visualización',
        type: 'Tipo de visualización',
        tableType: 'Tabla',
        lineChartType: 'Gráfico de líneas',
        areaChartType: 'Gráfico de áreas',
        barChartType: 'Gráfico de barras',
        cardType: 'Tarjeta',
        selectDataSource: 'Selecciona la Fuente de Datos',
        parameters: 'Parámetros de visualización',
        multidimensional: 'Multidimensional',
        unidimensional: 'Unidimensional',
      },
      datasource: {
        base: 'Base',
        custom: 'Custom',
        tables: 'FROM',
        group_by: 'GROUP BY',
        group_by_aggregations: 'GROUP BY - MÉTRICAS AGREGADAS',
        name: 'Selección del nombre',
        createDataSource: 'Crear',
        create: 'Crear Fuente de Datos',
        select_tables: 'Seleccionar tablas:',
        select_columns: 'Seleccionar columnas:',
        select_date_trunc_unit: 'Seleccionar unidad de truncado de tiempo:',
        select_name: 'Seleccionar nombre:',
        column: 'Columna',
        function: 'Función',
        order_by: 'ORDER BY',
        order_by_direction: 'Sentido',
        filters: 'WHERE',
        select_filters: 'Seleccionar filtros:',
        select_logical_operator: 'Selecciona operador lógico:',
        add_filter: 'Añadir filtro',
        edit_filter: 'Editar filtro',
        operator: 'Operador',
        value: 'Valor',
        column_selection: 'SELECT',
        metrics: 'Métricas',
        group_by_filters: 'GROUP BY - HAVING',
        add_aggregation: 'Añadir métrica agregada',
      },
      metric: {
        name: 'Nombre de la Métrica',
        selectDataSource: 'Selección de la Fuente de Datos',
        selectAggregation: 'Selección de la Agregación',
        aggregateFunction: 'Selecciona la Función de Agregación',
        aggregateColumn: 'Selecciona la Columna a agregar',
      },
      name_invalid: 'Nombre del dashboard no es válido',
      name_invalid_characters:
        'El nombre del dashboard no debe contener caracteres especiales',
      description_invalid_characters:
        'La descripción del dashboard no debe contener caracteres especiales',
      name: 'Nombre del dashboard',
      description: 'Descripción del dashboard',
      table: {
        name: 'Nombre',
        description: 'Descripción',
        version: 'Versión',
        created_at: 'Fecha creación',
        updated_at: 'Última modificación',
        actions: 'Borrar',
      },
      valueInput: {
        noValueRequired: 'No es necesario ningún valor',
        chipsHint: 'Escribe un valor y presiona Enter para añadirlo',
        from: 'Desde',
        to: 'Hasta',
        rangeHint:
          'Ingrese los límites inferior y superior. Deje un campo vacío para un rango abierto',
      },
    },
    surveys: {
      title: 'Encuestas',
      add: 'Crear encuesta',
      name: 'Nombre de la encuesta',
      name_required: 'El nombre de la encuesta es obligatorio',
      description: 'Descripción de la encuesta',
      study: 'Estudio',
      priority: 'Tipo de encuesta',
      priority_values: {
        mandatory: 'Obligatoria',
        optional: 'Opcional',
      },
      send_frequency_days: 'Frecuencia de envío (días)',
      response_time_limit_days: 'Límite de tiempo de respuesta (días)',
      starts_at: 'Fecha de inicio',
      start_date_required: 'La fecha de inicio es obligatoria',
      anonymization_type: 'Tipo de anonimización',
      anonymization_type_values: {
        none: 'Encuesta no anónima',
        all_answers: 'Encuesta totalmente anónima',
        optional: 'Opcional',
      },
      anonymization_optional_helper: '(el usuario elige al responder)',
      send_strategy: 'Estrategia de envío',
      send_strategy_values: {
        all_users: 'Todos los usuarios de las organizaciones',
        admin_only: 'Solo el administrador de las organizaciones',
      },
      recipients: 'Destinatarios',
      user_name: 'Nombre del usuario',
      org_name: 'Nombre de la organización',
      state: 'Estado',
      days_left: 'Días restantes',
      recipient_states: {
        pending: 'Pendiente',
        answered: 'Respondida',
        overdue: 'Vencida',
      },
      organization_ids: 'Organizaciones destinatarias',
      select_role: 'Seleccionar roles',
      select_organizations: 'Seleccionar organizaciones',
      selected_organizations: 'Seleccionadas',
      search_organizations: 'Buscar organizaciones',
      select_strategy: 'Seleccionar estrategia',
      depends_on_field: '¿Depende de alguna pregunta?',
      select_field: 'Seleccionar pregunta',
      depends_on_value: '¿De qué valor depende?',
      select_value: 'Seleccionar valor',
      configuration: 'Configuración',
      survey_questions: 'Preguntas',
      survey_fields: 'Campos de la encuesta',
      question_title: 'Título de la pregunta',
      field_name: 'Nombre del campo',
      question_type: 'Tipo de pregunta',
      question_description: 'Descripción de la pregunta',
      field_title: 'Título del campo',
      field_type: 'Tipo de campo',
      added_options: 'Opciones disponibles',
      field_types: {
        text: 'Texto',
        number: 'Número',
        boolean: 'Si/No',
        select: 'Opciones',
        multiselect: 'Opciones múltiples',
      },
      question_options: 'Opciones de la pregunta',
      add_question: 'Agregar pregunta',
      add_questions: 'Agregar preguntas',
      questions_added: '{{count}} preguntas agregadas',
      add_question_option: 'Agregar opción',
      added_question_options: 'Opciones agregadas',
      one_time_send: 'Envío puntual',
      no_limit: 'Sin límite',
      field_dependency: 'Depende de',
      select: 'Seleccionar',
      required: 'Pregunta obligatoria',
      template_required: 'Se requiere al menos una pregunta de la encuesta',
      name_survey_required: 'El nombre de la encuesta es requerido',
      starts_at_required: 'La fecha de inicio es requerida',
      question_name_duplicate: 'Ya existe una pregunta con este nombre',
      warning: 'Advertencia',
      cannot_delete_field_has_dependencies:
        'No se puede eliminar esta pregunta porque otra pregunta depende de ella.',
      delete: {
        confirm_header: 'Eliminar Encuesta',
        confirm_message: '¿Estás seguro de que quieres eliminar "{{name}}"?',
        confirm_accept: 'Eliminar',
        confirm_reject: 'Cancelar',
        success_summary: 'Eliminada',
        success_detail: '"{{name}}" ha sido eliminada correctamente.',
        error_summary: 'Error',
        error_detail:
          'Error al eliminar la encuesta. Por favor, inténtalo de nuevo.',
      },
      table: {
        name: 'Nombre',
        description: 'Descripción',
        version: 'Versión',
        created_at: 'Fecha de creación',
        updated_at: 'Última modificación',
        created_by: 'Creado por',
        active: 'Estado',
        filters: {
          created_by: 'Buscar por usuario...',
        },
        details: 'Detalles',
      },
      borrar: 'Eliminar',
      pausar: 'Pausar',
      reanudar: 'Reanudar',
      add_recipients: 'Añadir destinatarios',
      delete_recipients: 'Eliminar destinatarios',
      descargarrespuestasencvs: 'Descargar respuestas',
      paused: 'Pausado',
      information: 'Información',
      save: 'Guardar',
      confirm_save_message:
        '¿Deseas crear la encuesta? No se podrá modificar el contenido una vez creada la encuesta',
      select_all: 'Seleccionar todos',
      deselect_all: 'Quitar todos',
      drafts_title: 'Borradores',
      untitled_draft: 'Borrador sin título',
      created_by: 'Creado por',
      last_edited: 'Última edición',
      no_drafts: 'No hay borradores',
      saveDraft: 'Guardar borrador',
      edit_draft: 'Editar borrador',
      delete_draft: 'Eliminar borrador',
      confirm_delete_draft_header: 'Eliminar borrador',
      confirm_delete_draft_message:
        '¿Seguro que quieres eliminar este borrador? Esta acción no se puede deshacer.',
      exitConfirmHeader: 'Cambios sin guardar',
      exitConfirmMessage: 'Tienes cambios sin guardar',
      exitWithoutSaving: 'Salir sin guardar',
      section_general: 'Información general',
      section_configuration: 'Tipo de encuesta y anonimización',
      section_scheduling: 'Programación',
      section_recipients: 'Destinatarios',
      responses: 'Han respondido',
      overdue_users: 'Usuarios vencidos',
      saveDraftConfirmHeader: 'Guardar borrador',
      saveDraftConfirmMessage:
        'Las organizaciones destinatarias no se guardarán en el borrador. ¿Está seguro de que desea guardar el borrador?',
    },
    incidents: {
      titleMenu: 'Incidencias y OM',
      codeIncidence: 'Código de incidencia',
      titleSingle: 'Incidencia',
      detected: 'Detectado por',
      detection: 'Detección',
      comunication_channel: 'Canal de comunicación',
      confirmClose: ' Confirmación de cierre de incidencia',
      confirmCloseMessage:
        '¿Está seguro de que desea cerrar la incidencia? Esta acción no se puede deshacer.',
      dateClosedIncidence: 'Fecha de cierre',
      autoCloseInfo:
        'Al aceptar, la incidencia se marcará como cerrada. Se registrará automáticamente la fecha y hora de cierre. Esta acción no generará una orden de mantenimiento asociada.',
      doubleConfirmClose: '¿Confirmas que deseas cerrar esta incidencia?',
      noOpcionIncidences:
        'No hay opciones disponibles para prioridad/tipo/gravedad en este momento.',
      statusScope: {
        open: 'Abiertas',
        closed: 'Cerradas',
        placeholder: 'Selecciona un estado',
      },
      alarms: {
        title: 'Alarmas',
      },
      buttonAssing: 'Asignar Incidencia a OM',
      buttonCreateOM: 'Crear OM en incidencia',
      buttonCloseOM: 'Cerrar OM',
      buttonCloseIncidence: 'Cerrar Incidencia',
      lastMonth: 'Último mes por defecto',
      sn_product: 'Número de serie',
      notDetails: 'No hay detalles disponibles para esta incidencia.',
      assignOrder: 'Asignar orden de mantenimiento',
      serial_number: 'Número de serie',
      detected_by: 'Detectado por',
      created_at: 'Fecha de creación',
      date_closed: 'Fecha cierre',
      assigned: 'Asignado a',
      create: 'Crear incidencia',
      createIncident: 'Crear incidencia',
      createOrder: 'Crear orden de mantenimiento',
      impact: 'Gravedad',
      containment_actions: 'Acciones de contención',
      create_description:
        'Complete los detalles de la incidencia. Puede crear una órden de mantenimiento o asociar alguna que ya haya creada. Haga clic en guardar cuando termine.',
      d_id: 'Número de serie del dispositivo',
      date: 'Fecha y hora de entrada',
      description: 'Descripción',
      description_title: 'Descripción',
      details: 'Detalles de la incidencia',
      notAvailable: 'No disponible',
      device_name: 'Dispositivo',
      edit: 'Editar incidencia',
      estado_incidencia: {
        abierta: 'Pendiente',
        cancelada: 'Cancelada',
        cerrada: 'Cerrada',
        en_espera: 'En Espera',
        en_proceso: 'En Proceso',
        reabierto: 'Reabierto',
        resuelta: 'Resuelta',
        verificada: 'Verificada',
      },
      omAssigned: 'Órdenes de mantenimiento asignadas',
      notAssigned:
        'Esta incidencia no tiene órdenes de mantenimiento asignadas.',
      titleOrder: 'Orden de mantenimiento',

      origin: 'Origen',

      priority: 'Prioridad',
      priority_type: {
        alta: 'Alta',
        baja: 'Baja',
        critica: 'Crítica',
        media: 'Media',
      },
      search_device_name: 'Buscar por nombre del dispositivo',
      search_priority: 'Buscar por prioridad',
      search_status: 'Buscar por estado',
      search_title: 'Buscar por nombre de la incidencia',
      start_time: 'Fecha detección',
      status: 'Estado',
      title: 'Incidencias y órdenes de mantenimiento',
      type: 'Tipo',
      createMaintenanceOrder: {
        maintenance_type_label: 'Tipo Mantenimiento',
        order_status_label: 'Estado Orden Mantenimiento',
        responsible_label: 'Responsable',
        button_add_om: 'Agregar OM',
        maintenance_type_placeholder: 'Selecciona tipo de mantenimiento',
        order_status_placeholder: 'Selecciona estado de la orden',
        description_placeholder: 'Descripción de la orden de mantenimiento',
      },
      assignIncidentToOm: {
        title: 'Asignar Incidencias',
        incident_label: 'Incidencia',
        search_incident_placeholder: 'Busca una incidencia...',
        no_device:
          'La orden de mantenimiento no tiene un número de serie asociado',
        none_available: 'No hay incidencias disponibles para este equipo',
        same_device_hint:
          'Solo se muestran incidencias abiertas del mismo equipo.',
      },
      closeComment: 'Comentario',
      open: 'Abierta',
      closed: 'Cerrada',
      response_time: 'Tiempo de respuesta',
      confirmCloseButton: 'Cerrar incidencia',
      closeCommentRequired: 'El comentario de cierre es obligatorio',
      assignOrder_noDevice:
        'La incidencia no tiene un número de serie asociado',
      assignOrder_noneAvailable:
        'No hay órdenes de mantenimiento disponibles para este equipo',
      assignOrder_sameDeviceHint:
        'Solo se muestran órdenes de mantenimiento abiertas del mismo equipo.',
    },
    maintenance_orders: {
      detailsOm: 'Detalles de la órden de mantenimiento',
      details: 'Detalles',
      can_not_load: 'No se ha podido cargar',
      associated_incidences: 'Incidencias asociadas',
      no_incidences: 'No hay incidencias asociadas',
      allocated_times: 'Tiempos imputados',
      allocate_time: 'Imputar tiempo',
      no_allocated_times: 'No hay tiempos imputados',
      code: 'Código',
      description: 'Descripción',
      status: 'Estado',
      type: 'Tipo',
      creation_date: 'Fecha de creación',
      execution_date: 'Fecha de ejecución',
      close_date: 'Fecha de cierre',
      component_serial_number: 'Número de serie del componente',
      component_description: 'Descripción del componente',
      observations: 'Observaciones',
      allocate_time_error: 'No se ha podido imputar el tiempo',
      initial_date: 'Fecha inicial',
      final_date: 'Fecha final',
      comments: 'Comentarios',
      duration: 'Duración',
      final_before_initial: 'La fecha final debe ser posterior a la inicial',
      assigned_materials: 'Materiales Asignados',
      articles_to_assign: 'Artículos para Asignar',
      select_series: 'Seleccionar serie',
      remove_material: 'Eliminar material',
      no_assigned_materials: 'No hay materiales asignados aún',
      no_articles_available: 'No hay artículos disponibles',
      confirm_remove_material_title: 'Confirmar eliminación',
      confirm_remove_material_message:
        '¿Está seguro de que desea eliminar este material?',
      material_removed_success: 'Material eliminado exitosamente',
      error_removing_material: 'Error al eliminar material',
      article: 'Artículo',
      id: 'ID',
      cost: 'Costo',
      series: 'Serie',
      quantity: 'Cantidad',
      unit_cost: 'Costo Unitario',
      total_cost: 'Costo Total',
      date: 'Fecha',
      assign_material: 'Asignar material',
      available_quantity: 'Cantidad disponible',
      no_data: 'No hay datos disponibles',
      labelDescription: 'Escriba elemento a buscar',
      closeDialog: {
        title: '¿Quieres cerrar esta orden de mantenimiento?',
        description:
          'Al cerrar la OM, Marsinet registrará la fecha y hora de cierre, el usuario que realiza el cierre, las incidencias resueltas asociadas y las imputaciones de materiales y tiempos si existen.',
        orderLabel: 'Orden de mantenimiento',
        statusActual: 'Estado actual',
        closingDateTime: 'Fecha y hora de cierre',
        confirmDescription:
          'La fecha y hora definitiva se registrará en el momento exacto de confirmar el cierre.',
        associatedIncidents:
          'Incidencias asociadas que se marcarán como resueltas',
        notAssociatedIncidences: 'No hay incidencias asociadas a esta OM',
        associatedImputations: 'Imputaciones asociadas',
        materialImputations: 'Materiales imputados:',
        timeImputations: 'Tiempos imputados:',
        closeActionDescription:
          'Esta acción cerrará la orden de mantenimiento y actualizará su estado.',
        closeTitle: 'Cierre de la orden de mantenimiento',
        subtitle: 'Datos de la orden',
        closingComment: 'Comentario de cierre',
        closingCommentPlaceholder:
          'Describe cómo se han resuelto las incidencias seleccionadas',
        closingCommentHelp:
          'Se guardará como comentario de cierre en cada incidencia resuelta.',
        commentRequiredError: 'El comentario de cierre es obligatorio',
        confirmSingleResolved:
          'Marca las incidencias que quedan resueltas con este cierre',
        loadingIncidents: 'Cargando incidencias asociadas...',
        mustCloseIncidentHint:
          'Marca al menos una incidencia como resuelta y añade un comentario de cierre',
        noIncidentsToCloseError:
          'La orden no tiene incidencias asociadas que se puedan cerrar',
        singleIncidentRequiredError:
          'Debes marcar la incidencia asociada como resuelta para cerrar la orden',
        noIncidentSelectedError:
          'Debes marcar al menos una incidencia como resuelta',
        closed: 'Orden de mantenimiento cerrada correctamente',
        close_error: 'No se ha podido cerrar la orden de mantenimiento',
        incidences_close_error:
          'La orden se ha cerrado, pero no se han podido cerrar {{count}} incidencias',
      },

      responsible: 'Responsable',
      evidences: 'Evidencias',
      employee: 'Empleado',
      assigned_user: 'Usuario asignado',
      allocation_date: 'Fecha de imputación',
      material: 'Material',
      select_material: 'Selecciona un material',
      available: 'disponibles',
      no_available_materials: 'No hay materiales disponibles',
      material_assigned_success: 'Material asignado correctamente',
      assign_material_error: 'No se ha podido asignar el material',
      site: 'Centro',
      select_site: 'Selecciona un centro',
      warehouse: 'Almacén',
      select_warehouse: 'Selecciona un almacén',
      warehouse_location: 'Ubicación',
      select_warehouse_location: 'Selecciona una ubicación',
      can_not_load_incidences:
        'No se han podido cargar las incidencias asociadas',
      can_not_load_allocated_times:
        'No se han podido cargar los tiempos imputados',
      can_not_load_available_materials:
        'No se han podido cargar los materiales disponibles',
      pdf_download_error: 'No se ha podido descargar el PDF',
      changeStatus: {
        title: 'Cambiar el estado de la orden',
        button: 'Cambiar estado',
        current: 'Estado actual',
        new: 'Nuevo estado',
        help: 'Los estados finales no están disponibles: la orden se termina desde el flujo de cierre.',
        updated: 'Estado actualizado correctamente',
        error: 'No se ha podido actualizar el estado',
      },
    },
    ingestions: {
      model: 'Modelo',
      role: 'Rol',
      selectRole: 'Buscar por rol',
      action: 'Acción',
      date: 'Fecha',
      download: 'Descargar',
      downloadFiles: 'Descargar archivos',
      graphs: 'Gráficos',
      id: 'ID',
      is_session: 'Sesión',
      is_session_false: 'No',
      is_session_true: 'Sí',
      is_test: '¿Es una prueba?',
      name: 'Nombre del archivo',
      notProcessed: 'No procesado',
      process: 'Procesado',
      processed: 'Procesado',
      see_details: 'Ver detalles',
      detailsTitle: 'Detalles del error',
      ingestion_error_code: 'Descripción de error',
      ingestion_error: 'Detalles del error',
      name_zip: 'Nombre del archivo .zip',
      search: 'Buscar por nombre de archivo o numero de serie del dispositivo',
      search_battery_cycles: 'Buscar por ciclos de carga',
      search_d_name: 'Buscar por número de serie del dispositivo',
      search_name: 'Buscar por nombre de archivo',
      selectState: 'Selecciona un estado',
      title: 'Ingesta de sesión',
      versions: 'Versiones',
      dateFormatHint: 'Ejemplo de fecha a buscar 01022026',
      placeHolderDate: '01022026',
      with_errors: 'Con errores',
      without_errors: 'Sin errores',
    },
    errors: {
      ZIP_MISSING_JSON_OR_CSV: 'Archivo ZIP sin JSON o CSV',
      DEVICE_NOT_FOUND: 'Dispositivo no encontrado',
      CSV_NO_ROWS: 'CSV sin contenido',
      PATIENT_NOT_FOUND: 'Paciente no encontrado',
      JSON_MALFORMED: 'El JSON está mal formado',
      ZIP_INVALID_FORMAT: 'Formato de ZIP inválido',
      INVALID_SIGNATURE: 'Firma inválida',
      DIRECTORY_NOT_FOUND: 'Directorio no encontrado',
      notErrors: 'No hay detalles específicos disponibles para este error',
      BLOB_NOT_FOUND_OR_ACCESS_DENIED: 'No se pudo acceder al archivo en el almacenamiento',
      MISSING_DEVICE_AND_PATIENT_ID: 'El archivo no contiene ID de dispositivo ni de paciente',
      DEVICE_ID_NOT_FOUND: 'El archivo no contiene el ID del dispositivo',
      PATIENT_ID_NOT_FOUND: 'El archivo no contiene el ID del paciente',
      INVALID_SESSION_DATA: 'Datos de sesión inválidos en el archivo CSV',
      ZIP_INVALID_STRUCTURE: 'Estructura del archivo ZIP inválida',
      CSV_TOO_LARGE: 'El archivo CSV supera el tamaño máximo permitido',
      CSV_PROCESSING_ERROR: 'Error al procesar el archivo CSV',
      ALARMS_PROCESSING_ERROR: 'Error al procesar alarmas',
      UNKNOWN_ERROR: 'Error inesperado al procesar el archivo',


    },
    institutions: {
      add: 'Crear organización',
      control_panel: 'Panel de control',
      bubble: {
        detailsOf: 'Detalles de',
        detailsOfOrganization: 'Detalles de la organización',
        devicesNumberProducing: 'Dispositivos en producción',
        deviceNumberStock: 'Dispositivos en stock',
        deviceNumberRentedOrPurchased: 'Dispositivos alquilados o comprados',
        deviceNumberInMaintenance: 'Dispositivos en mantenimiento',
        deviceNumberDisabled: 'Dispositivos inactivos',
        familiesNumber: 'Número de familias',
        noData: 'Sin datos',
        other: 'Otros dispositivos',
      },
      form: {
        address: 'Dirección',
        addressRequired: 'Dirección es requerida',
        city: 'Ciudad',
        cityRequired: 'Ciudad es requerida',
        contact: 'Datos de contacto',
        contactname: 'Nombre',
        country: 'País',
        countryRequired: 'País es requerido',
        devicesNotFound:
          'No se han encontrado dispositivos para esta organización',
        email: 'Correo electrónico',
        name: 'Nombre Organización',
        nameRequired: 'Nombre es requerido',
        number: 'Número',
        numberRequired: 'Número es requerido',
        postalCode: 'Código postal',
        postalCodeRequired: 'Código postal es requerido',
        premium: 'Premium',
        telephone: 'Teléfono',
        warningDeleteDeviceTitle: 'Acción no recomendada',
        warningDeleteDeviceMessage:
          'Este es el último dispositivo vinculado a la organización. Si lo elimina sin asignar otro antes, la organización dejará de estar visible para usted hasta que se le asigne un nuevo dispositivo desde la administración.',
        creator: 'Creador',
        changeCreator: 'Cambiar creador',
        creatorNotFound: 'Sin creador'
      },
      messages: {
        blocked:
          'No se pueden acceder a los datos de esta organización por que está bloqueada.',
        delete: 'Organización eliminada',
        deleteConfirm:
          '¿Está seguro que desea eliminar la organización y la relacion con sus dispositivos?',
        deleteConfirmTitle: 'Confirmación de eliminación',
        deleteError: 'Error al eliminar la organización',
        deleteSuccess: 'Organización eliminada correctamente',
      },
      table: {
        actions: 'Acciones',
        id: 'ID',
        name: 'Nombre organización',
        premium: 'Premium',
        role: 'Rol',
        created_by: 'Creador',
      },
      title: 'Listado organizaciones',
    },
    login: {
      email: 'Email',
      forgotPassword: '¿Olvidaste tu contraseña?',
      invalidCharacters: 'Email contiene caracteres inválidos',
      invalidCredentials: 'Usuario y Contraseña inválidos',
      invalidEmail: 'Email inválido',
      login: 'Iniciar sesión',
      or: 'O',
      password: 'Contraseña',
      register: 'Registrarse',
      requiredEmail: 'Email es requerido',
      requiredPassword: 'Contraseña es requerida',
      slogan: {
        a: 'Conectando datos,',
        b: 'transformando vidas',
      },
    },
    maintenance: {
      alarms: {
        title: 'Alarmas',
      },
      ingestion: {
        abdl: 'Abducción I',
        abdr: 'Abducción D',
        anckle_lock: 'Bloqueo de tobillo',
        assistedTorque: 'Par de asistencia',
        batery: 'Batería',
        battery_cycles: 'Ciclos de carga',
        chest: 'Peto',
        config: 'Configuración',
        corseLC: 'L corto',
        corseLE: 'L envolvente',
        corseSC: 'S corto',
        corseSE: 'S envolvente',
        corset: 'Corsé',
        current: 'Corriente',
        d_name: 'Número de serie',
        dorsal_flex_max: 'Flexión dorsal máxima',
        elev_control: 'Control de elevación',
        elev_ctrl: 'Control de elevación',
        elev_motor: 'Motor de elevación',
        elev_sens: 'Sensor de elevación',
        energy_monitor: 'Monitor de energía',
        env_temp: 'Temperatura del entorno',
        exo: 'Exoesqueleto',
        femurl: 'Fémur I',
        femurr: 'Fémur D',
        file: 'Archivo',
        flexanklel: 'Flexos tobillo I',
        flexankler: 'Flexos tobillo D',
        flexkneel: 'Flexos rodilla I',
        flexkneer: 'Flexos rodilla D',
        flexoshipl: 'Flexos cadera I',
        flexoshipr: 'Flexos cadera D',
        generalInformation: 'General',
        generalState: 'Estado general',
        global_position: 'Posición global',
        graphs: {
          aan1LevelAssistanceLh: 'AAN1 Cadera Izquierda',
          aan1LevelAssistanceLk: 'AAN1 Rodilla Izquierda',
          aan1LevelAssistanceRh: 'AAN1 Cadera Derecha',
          aan1LevelAssistanceRk: 'AAN1 Rodilla Derecha',
          aan2LevelAssistanceLh: 'AAN2 Cadera Izquierda',
          aan2LevelAssistanceLk: 'AAN2 Rodilla Izquierda',
          aan2LevelAssistanceRh: 'AAN2 Cadera Derecha',
          aan2LevelAssistanceRk: 'AAN2 Rodilla Derecha',
          assistedTorqueLeftHip: 'Par cadera izquierda',
          assistedTorqueRightHip: 'Par cadera derecha',
          assistedTorqueLeftKnee: 'Par rodilla izquierda',
          assistedTorqueRightKnee: 'Par rodilla derecha',
          capacity: 'Porcentaje',
          current1: 'ABD-I',
          current2: 'CI',
          current3: 'RI',
          current4: 'TI',
          current5: 'ABD-D',
          current6: 'CD',
          current7: 'RD',
          current8: 'TD',
          elevCtrl: 'Control de elevación',
          elevSens: 'Distancia',
          energyMonitorExo: 'Exoesqueleto',
          energyMonitorWf: 'Andador',
          environmentTemperature: 'Temperatura',
          globalPosition: 'Posición global',
          imuPitchAngle: 'Ángulo de inclinación en plano sagital',
          imuRollAngle: 'Ángulo de inclinación en plano frontal',
          intentionEffortHipLeft: 'CI Fuerza de activación',
          intentionEffortHipRight: 'CD Fuerza de activación',
          intentionEffortKneeLeft: 'RI Fuerza de activación',
          intentionEffortKneeRight: 'RD Fuerza de activación',
          load_cell: 'Célula de carga',
          lowerLimit: 'Límite inferior',
          maxLegend: 'Has llegado al máximo de 12 variables seleccionadas',
          motorTemperature1: 'ABD-I',
          motorTemperature2: 'CI',
          motorTemperature3: 'RI',
          motorTemperature4: 'TI',
          motorTemperature5: 'ABD-D',
          motorTemperature6: 'CD',
          motorTemperature7: 'RD',
          motorTemperature8: 'TD',
          motorTorque1: 'ABD-I',
          motorTorque2: 'CI',
          motorTorque3: 'RI',
          motorTorque4: 'TI',
          motorTorque5: 'ABD-D',
          motorTorque6: 'CD',
          motorTorque7: 'RD',
          motorTorque8: 'TD',
          motorsAngRef1: 'Referencia ABD-I',
          motorsAngRef2: 'Referencia CI',
          motorsAngRef3: 'Referencia RI',
          motorsAngRef4: 'Referencia TI',
          motorsAngRef5: 'Referencia ABD-D',
          motorsAngRef6: 'Referencia CD',
          motorsAngRef7: 'Referencia RD',
          motorsAngRef8: 'Referencia TD',
          motorsEn: 'Motores habilitados',
          motorsInt1: 'ABD-I',
          motorsInt2: 'CI',
          motorsInt3: 'RI',
          motorsInt4: 'TI',
          motorsInt5: 'ABD-D',
          motorsInt6: 'CD',
          motorsInt7: 'RD',
          motorsInt8: 'TD',
          motorsMotor1Mille: 'Mille ABD-I',
          motorsMotor1Orbis: 'Ángulo ABD-I',
          motorsMotor2Mille: 'Mille CI',
          motorsMotor2Orbis: 'Ángulo CI',
          motorsMotor3Mille: 'Mille RI',
          motorsMotor3Orbis: 'Ángulo RI',
          motorsMotor4Mille: 'Mille TI',
          motorsMotor4Orbis: 'Ángulo TI',
          motorsMotor5Mille: 'Mille ABD-D',
          motorsMotor5Orbis: 'Ángulo ABD-D',
          motorsMotor6Mille: 'Mille CD',
          motorsMotor6Orbis: 'Ángulo CD',
          motorsMotor7Mille: 'Mille RD',
          motorsMotor7Orbis: 'Ángulo RD',
          motorsMotor8Mille: 'Mille TD',
          motorsMotor8Orbis: 'Ángulo TD',
          outrange: 'La selección está fuera de rango',
          position: 'Posición',
          realTorqueLeftHip: 'Real — Cadera izquierda',
          realTorqueRightHip: 'Real — Cadera derecha',
          realTorqueLeftKnee: 'Real — Rodilla izquierda',
          realTorqueRightKnee: 'Real — Rodilla derecha',
          refTorqueLeftHip: 'Referencia - Cadera izquierda',
          refTorqueRightHip: 'Referencia - Cadera derecha',
          refTorqueLeftKnee: 'Referencia — Rodilla izquierda',
          refTorqueRightKnee: 'Referencia — Rodilla derecha',
          sit_angle: 'Ángulo',
          state: 'Estado del dispositivo',
          sys_status: 'Estado de seguridad',
          temperature: 'Grados',
          thresholdHipFlexLeft: 'CI Umbral',
          thresholdHipFlexRight: 'CD Umbral',
          thresholdKneeFlexLeft: 'RI Umbral',
          thresholdKneeFlexRight: 'RD Umbral',
          timeWalking: 'Caminando',
          upperLimit: 'Límite superior',
          voltage: 'Voltios',
          motorEpos1: 'Epos1 CI',
          motorEpos2: 'Epos2 CD',
          motorEpos3: 'Epos3 RI',
          motorEpos4: 'Epos4 RD',
        },
        heightmarcoatlas: 'Altura marco',
        hip: 'Ancho de cadera',
        imuData: 'Ángulos de inclinación',
        loadCell: 'Celula de carga',
        motorSens2: 'Sensor orbis',
        motorsCurrent: 'Corriente',
        motorsInformation: 'Motores',
        motorsInt: 'Activación por fuerza',
        motorsRef: 'Angulos',
        motorsSens1: 'Sensor mille',
        motorsTemp: 'Temperatura',
        motorsTorque: 'Par',
        p_name: 'Nombre del paciente',
        percentage: 'Capacidad',
        plantar_flex_max: 'Flexión plantar máxima',
        refAndRealTorque: 'Par articular',
        shoe: 'Talla de zapato',
        sit_angle: 'Ángulo del asiento',
        state: 'Estado del dispositivo',
        sys_status: 'Estado de seguridad',
        tempEpos: 'Temperatura EPOS',
        temperature: 'Temperatura',
        tibial: 'Tibia I',
        tibiar: 'Tibia D',
        title: 'Ingestas de sesión',
        voltage: 'Voltaje',
        walker: 'Andador',
        walker_info: 'Andador',
      },
      test: {
        detail: 'Detalles de la prueba',
        fail: 'Fallido',
        ok: 'Completado',
        title: 'Ingesta de pruebas',
      },
      ota: {
        title: 'Carga de Firmware OTA',
        upload_description:
          'Carga nuevas versiones de firmware para los componentes del dispositivo (CM7, CM4 o ESP). El sistema validará los metadatos embebidos en el binario para garantizar la integridad.',
        software_type: 'Tipo de Software',
        select_software_type: 'Selecciona un tipo de software',
        software_types: {
          cm7_description: 'Procesador principal - Cerebro del dispositivo',
          cm4_description: 'Procesador de comunicaciones - Conectividad',
          esp_description: 'Procesador WiFi - Conectividad inalámbrica',
        },
        version_required: 'Versión del Firmware*',
        version_placeholder: 'Ej: 1.2.3',
        version_info: 'Ingresa la versión en formato semántico (X.Y.Z)',
        firmware_file: 'Archivo Firmware*',
        choose_file: 'Seleccionar archivo',
        selected_file: 'Archivo seleccionado',
        upload: 'Cargar',
        uploading: 'Cargando...',
        version: 'Versión',
        version_format_invalid:
          'El formato de versión no es válido. Usa el formato X.Y.Z',
        select_file_and_type:
          'Por favor, selecciona un archivo y un tipo de software',
        invalid_software_type: 'Tipo de software no válido',
        version_conflict:
          'La versión ya existe o es inferior a la última publicada',
        checksum_mismatch:
          'Error de integridad del archivo. El archivo pudo haberse corrompido durante la carga.',
        firmware_metadata: 'Metadatos del Firmware',
        project: 'Proyecto',
        binary_version: 'Versión de Binario',
        board_version: 'Versión de Placa',
        microcontroller_id: 'ID de Microcontrolador',
        creation_datetime: 'Fecha/Hora de Creación',
        file_metadata_version: 'Versión en metadatos del archivo',
        git_tag: 'Tag de Git',
        chip_id: 'ID del Chip',
        compilation_time: 'Hora de Compilación',
        compilation_date: 'Fecha de Compilación',
        upload_authorization: 'Token de Autorización de Carga',
        upload_authorization_info:
          'Pega el token de autorización recibido por email (opcional)',
        token_valid: '✓ Token de autorización válido',
        token_invalid_format: '❌ Formato de token de autorización inválido',
        dont_have_token: '¿No tienes un token de autorización?',
        request_token_button: 'Solicitar Token de Carga',
        token_request_sent:
          'Token mandado correctamente. Revisa tu bandeja de correo para obtenerlo.',
        token_already_used:
          'Error de autorización: El token de autorización ya ha sido utilizado',
        error_reading_file_metadata: 'Error al leer los metadatos del archivo',
        error_requesting_token: 'Error al solicitar el token',
        invalid_metadata:
          'No se puede cargar archivo con metadatos inválidos: ',
        version_mismatch_metadata:
          'Desajuste de versión con metadatos del archivo',
        token_required: 'El token de autorización de carga es obligatorio',
        token_format_invalid: 'El formato del token de carga es inválido',
      },
      title: 'Mantenimiento',
    },
    menu: {
      alarms: 'Alarmas',
      changepassword: 'Cambio de contraseña',
      devices: 'Dispositivos',
      home: 'Panel Principal',
      incidentsOMtitle: 'Incidencias y Órdenes de mantenimiento',
      titleIncidents: 'Incidencias',
      maintenance_orders_tab: 'Órdenes de mantenimiento',
      ingestions: 'Ingestas',
      institutions: 'Organizaciones',
      language: 'Idioma',
      maintenance: 'Mantenimiento',
      myAccount: 'Mi cuenta',
      patients: 'Pacientes',
      privacy: 'Privacidad',
      report: 'Informe',
      session_record: 'Registro de sesiones',
      sessions: 'Uso del dispositivo',
      signOut: 'Cerrar sesión',
      users: 'Usuarios',
      dashboards: 'Analíticas',
      ota: 'Carga de ficheros OTA',
      pendingSurveys: 'Encuestas pendientes',
      surveyCreation: 'Creación de encuestas',
      ID_incident: 'ID Incidencia',
    },
    notVerified: {
      error:
        'El email no está registrado en la base de datos, por favor vuelva a registrarse regístrese',
      success: 'La cuenta ha sido verificada con éxito',
    },
    patients: {
      add: 'Nuevo paciente',
      form: {
        abd: 'Abducción',
        abdl: 'Abducción izquierda',
        abdr: 'Abducción derecha',
        add: 'Añadir',
        addAffectation: 'Escribe una nueva afectación',
        address: 'Dirección',
        affectation: 'Nivel de afectación',
        ankle_lock: 'Bloqueo de tobillo',
        ankle_stance: 'Posición de tobillo',
        birthDate: 'Fecha de nacimiento',
        chest_size: 'Talla de peto',
        city: 'Ciudad',
        corset: 'Corsé',
        country: 'País',
        cp: 'Código postal',
        email1: 'Email de tutor legal 1',
        email2: 'Email de tutor legal 2',
        femur_len_l: 'Longitud del fémur izquierdo',
        femur_len_r: 'Longitud del fémur derecho',
        flex_dorsal_max: 'Flexión dorsal máxima',
        flex_plantar_max: 'Flexión plantar máxima',
        flexos_hip: 'Flexos cadera',
        flexos_knee: 'Flexos rodilla',
        height: 'Altura',
        height_marco_atlas: 'Altura marco atlas',
        hip_width: 'Ancho de cadera',
        institution: 'Organización',
        lastName: 'Apellidos',
        legalGuardian: 'Tutor legal',
        legal_guardian_name_1: 'Nombre de tutor legal 1',
        legal_guardian_name_2: 'Nombre de tutor legal 2',
        measurementSelector: 'Medida',
        mobilityLevels: {
          level1NoRestrictions: 'Nivel I - Camina sin restricciones',
          level2WithLimitations: 'Nivel II - Camina con limitaciones',
          level3WithAssistiveDevice:
            'Nivel III - Camina utilizando un dispositivo manual auxiliar de la marcha',
          level4LimitedSelfMobility:
            'Nivel IV - Auto-movilidad limitada, es posible que utilice movilidad motorizada',
          level5WheelchairTransport:
            'Nivel V - Transportado en silla de ruedas',
        },
        name: 'Nombre',
        nameLegalGuardian: 'Nombre tutor legal',
        nationality: 'Nacionalidad',
        nif: 'ID',
        number: 'Número',
        pathologies: {
          acquiredBrainInjury: 'Daño cerebral adquirido',
          ame1: 'Atrofia muscular espinal tipo 1',
          ame2: 'Atrofia muscular espinal tipo 2',
          ame3: 'Atrofia muscular espinal tipo 3',
          angelman: 'Síndrome de Angelman',
          ataxic: 'Parálisis cerebral atáxica',
          cerebralPalsy: 'Parálisis cerebral',
          cerebralPalsy2: 'Parálisis cerebral tipo 2',
          cerebralPalsy3: 'Parálisis cerebral tipo 3',
          cerebralPalsy4: 'Parálisis cerebral tipo 4',
          cerebralPalsy5: 'Parálisis cerebral tipo 5',
          cervical: 'Lesión medular cervical',
          duchenne: 'Distrofia muscular de Duchenne',
          dyskinetic: 'Parálisis cerebral discinética',
          geneticSynrome: 'Síndrome genético',
          lumbar: 'Lesión medular lumbar',
          medularInjury: 'Lesión medular',
          mixed: 'Parálisis cerebral mixta',
          muscularDystrophy: 'Distrofia muscular',
          myasthenia: 'Miastenia',
          myopathy: 'Miopatía',
          neuromuscularDisease: 'Enfermedad neuromuscular',
          other: 'Enfermedad rara',
          rett: 'Síndrome de Rett',
          spastic: 'Parálisis cerebral espástica',
          thoracic: 'Lesión medular torácica',
          wesSyndrome: 'Síndrome de Wes',
        },
        pathology: 'Diagnóstico',
        phone: 'Teléfono',
        placeHolderNameLegalGuardian: 'Indica nombre tutor legal',
        postalCode: 'Código postal',
        province: 'Provincia',
        rom_ankle: 'ROM tobillo',
        rom_hip: 'ROM cadera',
        rom_knee: 'ROM rodilla',
        sex: 'Sexo',
        sexOptionFemale: 'Mujer',
        sexOptionMale: 'Hombre',
        sexOptions: 'Seleccione sexo',
        shoe_size: 'Tamaño de zapato',
        tibia_len_l: 'Longitud de la tibia izquierda',
        tibia_len_r: 'Longitud de la tibia derecha',
        title: 'Nuevo paciente',
        treatment: 'Tratamiento',
        treatments: {
          hidrotherapy: 'Hidroterapia',
          hipotherapy: 'Hipoterapia',
          occupationalTherapy: 'Terapia ocupacional',
          rehabilitation: 'Rehabilitación convencional',
          strech: 'Estiramientos',
        },
        walker_len: 'Longitud del andador',
        sit_position: 'Altura en posición sentada',
        stand_position: 'Altura en posición de pie',
        weight: 'Peso',
        yearsOld: 'Años',
      },
      formValidation: {
        address: 'La dirección es requerida',
        birthDate: 'La fecha de nacimiento es requerida',
        city: 'La ciudad es requerida',
        country: 'El país es requerido',
        email: 'El email es requerido',
        emailFormat: 'El email no es válido',
        height: 'La altura es requerida',
        heightMin: 'La altura no puede ser menor que 0',
        invalidCountry: 'El país no es válido',
        invalidDate: 'La fecha no es válida',
        invalidNationality: 'La nacionalidad no es válida',
        lastName: 'Los apellidos son requeridos',
        name: 'El nombre es requerido',
        nationality: 'La nacionalidad es requerida',
        nif: 'El ID es requerido',
        nifInvalid: 'El ID no es válido',
        number: 'El número es requerido',
        numberInvalid: 'El número no es válido',
        pathology: 'El diagnóstico es requerida',
        phone: 'El teléfono es requerido',
        phoneMaxLength: 'El teléfono no puede tener más de 9 dígitos',
        phoneMinLength: 'El teléfono debe tener 9 dígitos',
        phoneNumbers: 'El teléfono sólo puede contener números',
        postalCode: 'El código postal es requerido',
        postalCodeInvalid: 'El código postal no es válido',
        postalCodeMaxLength: 'El código postal no puede tener más de 5 dígitos',
        postalCodeMinLength:
          'El código postal no puede tener menos de 5 dígitos',
        province: 'La provincia es requerida',
        sex: 'El sexo es requerido',
        treatment: 'El tratamiento es requerido',
        weight: 'El peso es requerido',
        weightMin: 'El peso no puede ser menor que 0',
      },
      messages: {
        create: 'Paciente creado',
        createError: 'Error al crear el paciente',
        createSuccess: 'Paciente creado correctamente',
        delete: 'Paciente eliminado',
        deleteConfirm:
          '¿Está seguro que desea eliminar el paciente?   Si lo haces se eliminará de tu organización.',
        deleteConfirmTitle: 'Confirmación de eliminación',
        deleteError: 'Error al eliminar el paciente',
        deleteSuccess: 'Paciente eliminado correctamente',
        device_not_found: 'No se ha encontrado el dispositivo',
        emailAlreadyExists: 'El email ya existe',
        organization_not_found: 'No se ha encontrado la organización',
        requestPasswordError: 'Usuario no encontrado',
        somethingUnexpectedHappened: 'Algo inesperado ha ocurrido',
        updateShareConfirm:
          'Marcando esta casilla, la aplicación no compartirá tus datos personales con profesionales sanitarios',
        updateShareConfirmTitle:
          '¿Estás seguro de que quieres dejar de compartir tus datos?',
        updateNoShareConfirm:
          'Desmarcando esta casilla, la aplicación compartirá tus datos personales con profesionales sanitarios',
        updateNoShareConfirmTitle:
          '¿Estás seguro de que quieres compartir tus datos?',
      },
      patientData: 'No compartir los datos personales del paciente',
      table: {
        actions: 'Acciones',
        filter: 'Buscar...',
        filters: {
          lastName: 'Apellidos...',
          lastSession: 'Última sesión....',
          name: 'Nombre...',
          p_id: 'ID Paciente...',
          sessions: 'Sesiones...',
          totalSteps: 'Pasos totales...',
        },
        institutions: 'Organizaciones',
        lastName: 'Apellidos',
        lastSession: 'Última sesión',
        name: 'Nombre',
        p_id: 'ID Paciente',
        sessions: 'Sesiones',
        total_steps: 'Pasos totales',
        device_model: 'Modelo del dispositivo',
        select_model: 'Selecciona un modelo',
        all_devices: 'Todos los dispositivos',
        no_devices:
          ' No hay sesiones para el modelo de dispositivo seleccionado en este rango.',
        no_sessions:
          'No hay sesiones disponibles para el intervalo de fechas seleccionado.',
      },
      title: 'Registro de sesiones',
      viewPatient: {
        threshold_force: 'Umbral de fuerza',
        anglesTitle: 'Ángulos',
        address: 'Dirección',
        clinicalData: 'Datos clínicos',
        config_patient: 'Configuración del paciente',
        data: 'Datos generales',
        editPatient: 'Editar datos',
        goBack: 'Volver Atrás',
        noSessions: 'No hay sesiones para este paciente',
        sessions: {
          assistanceLevel: 'Aportación del paciente',
          assistedTorque: 'Par de asistencia',
          fc: 'Frecuencia cardiaca',
          so2: 'Saturación de oxígeno',
          so2NoData: 'No hay datos de saturación de oxígeno',
          threshold: 'Umbral de frecuencia cardiaca',
          fc_max: 'Pulso cardiaco máximo',
          fc_med: 'Pulso cardiaco medio',
          amount: 'Cantidad',
          averageStepsSession: 'Media pasos / Sesión',
          averageTimeSession: 'Media tiempo / Sesión',
          avgStepTimeSeconds: 'Tiempo medio de pasos',
          bpm: 'bpm',
          cadence: 'Cadencia',
          cd: 'CD',
          cd_expanded: 'Cadera Derecha',
          ci: 'CI',
          ci_expanded: 'Cadera Izquierda',
          control: 'Control',
          daily: 'Diario',
          direction: 'Dirección',
          evolution: 'Evolución',
          fe_hl: 'Flexoextensión de cadera izquierda',
          fe_hr: 'Flexoextensión de cadera derecha',
          fe_kl: 'Flexoextensión de rodilla izquierda',
          fe_kr: 'Flexoextensión de rodilla derecha',
          flexValue: 'Flexo {{value}}',
          from: 'Desde',
          gait_cycle: 'Ciclo de la marcha (%)',
          gaitKinematicsAnalysis: 'Análisis de la cinemática de la marcha',
          general: 'General',
          generate: 'Generar informe',
          hip: 'Cadera',
          hipFlexionDistribution: 'Distribución de flexos de cadera',
          inSession: 'En sesión',
          joint_ang: 'Ángulo articular (º)',
          jointPosition: 'Posición articular',
          knee: 'Rodilla',
          kneeFlexionDistribution: 'Distribución de flexos de rodilla',
          leftLeg: 'pierna izquierda',
          romHipLeft: 'ROM CI',
          romKneeLeft: 'ROM RI',
          romAnkleLeft: 'ROM TI',
          romHipRight: 'ROM CD',
          romKneeRight: 'ROM RD',
          romAnkleRight: 'ROM TD',
          leftSideEffortAndThreshold:
            'Fuerzas y umbrales de activación de pierna izquierda',
          mean: 'Media',
          minutes: 'Minutos',
          mode: 'Modo',
          monthly: 'Mensual',
          newton: 'N*m',
          points: 'Puntos',
          rd: 'RD',
          rd_expanded: 'Rodilla Derecha',
          ri: 'RI',
          ri_expanded: 'Rodilla Izquierda',
          rightLeg: 'pierna derecha',
          rightSideEffortAndThreshold:
            'Fuerzas y umbrales de activación de pierna derecha',
          score: 'Puntuación',
          sd: 'Desviación típica',
          seconds: 'Segundos',
          sessionDetails: 'Detalles de la sesión',
          steps: 'Pasos',
          stepsBackward: 'Pasos hacia atrás',
          stepsDistribution: 'Distribución de pasos',
          stepsForward: 'Pasos hacia adelante',
          stepsPerMinute: 'Pasos por minuto',
          thresholdConfiguration: 'Configuración de umbrales',
          time: 'Tiempo',
          timeDistribution: 'Distribución de tiempo',
          title: 'Sesiones',
          to: 'Hasta',
          torque: 'Fuerza de activación por articulación (máximo diario)',
          totalSessions: 'Total sesiones',
          totalSteps: 'Total pasos',
          totalTime: 'Tiempo total de uso',
          totalTimeWalking: 'Tiempo total caminando',
          vitals: 'Constantes vitales',
          combined: 'Modo + Dirección',
          noDataForGraph: 'No hay datos para el gráfico seleccionado',
        },
      },
    },
    register: {
      successTitle: 'Registro exitoso',
      acept: 'He leído y acepto ',
      addCodes: 'Añadir dispositivos',
      address: 'Dirección',
      ai: 'Consiento que las metricas recolectadas sean utilizadas para mejorar el servicio con fines de investigación y desarrollo mediante inteligencia artificial',
      analytics:
        'Consiento que se recolecten datos sobre el uso de la aplicación de forma anónima con el fin de mejorar el servicio y poder dar una respuesta más rápida frente a averías o incidencias',
      birthDate: 'Fecha de Nacimiento',
      birth_dateRequired: 'Fecha de nacimiento es requerida',
      birthdateRequired: 'Fecha de nacimiento es requerida',
      change_policy:
        'Los demás campos son opcionales y su información será utilizada para personalizar y mejorar tu experiencia. Puedes cambiar tus preferencias en cualquier momento en la sección de Mi Cuenta.',
      charge: 'Cargo',
      chargeRequired: 'Cargo es requerido',
      city: 'Ciudad',
      cityInvalid: 'Ciudad inválida',
      cityInvalidCharacters: 'Ciudad contiene caracteres inválidos',
      cityRequired: 'Ciudad es requerida',
      clinic: 'Profesional',
      confidentiality: 'la política de privacidad',
      cookiePolicy: 'la política de cookies',
      passwordMax: 'La contraseña no puede tener más de 20 caracteres',
      cookiePolicyTexts: {
        acceptanceRejectionOrDeletionText1:
          'Este sitio web muestra información sobre su Política de Cookies en la parte inferior o superior del portal en cada inicio de sesión con el objeto de que usted sea consciente e informado de ello.',
        acceptanceRejectionOrDeletionText2:
          'Puede usted aceptar la instalación de las cookies en su navegador web que podrá encontrar en el panel informativo mediante un botón que le permita aceptar todas las cookies a través de una clara acción afirmativa y positiva.',
        acceptanceRejectionOrDeletionText3:
          'También puede usted rechazar el uso de cookies mediante la selección de negarse a la instalación y su uso en su navegador pulsando el botón para rechazarlas en bloque. Sin embargo, debe saber que si lo hace puede ser que no pueda gozar de la plena funcionalidad de este sitio web.',
        acceptanceRejectionOrDeletionText4:
          'En última instancia, tiene usted la posibilidad de borrar las cookies previamente instaladas desde la configuración del propio navegador que esté utilizando para ello.',
        acceptanceRejectionOrDeletionTitle:
          'ACEPTACIÓN, RECHAZO O ELIMINACIÓN DE LAS COOKIES',
        accordingToOwnershipText1:
          'Cookies propias:    son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.',
        accordingToOwnershipText2:
          'Cookies de terceros:    son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies',
        accordingToOwnershipTitle: 'SEGÚN LA PROPIEDAD',
        accordingToTheConservationPeriodText1:
          'Cookies de sesión:    son un tipo de cookies diseñadas para recabar y almacenar datos mientras el usuario accede a una página web.',
        accordingToTheConservationPeriodText2:
          'Cookies persistentes:    son un tipo de cookies en el que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un período definido por el responsable de la cookie, y que puede ir de unos minutos a varios años.',
        accordingToTheConservationPeriodTitle: 'SEGÚN EL PLAZO DE CONSERVACIÓN',
        changingTheCookieSettingsText1:
          'Siguiendo las directrices europeas de la normativa de protección de datos que puedan verse afectados por el uso de cookies, usted puede restringir, bloquear o borrar las cookies utilizando su navegador. En cada navegador la operativa es diferente, la función de "Ayuda" le mostrará cómo hacerlo.',
        changingTheCookieSettingsText2:
          'Además, también puede gestionar el almacén de cookies en su navegador a través de herramientas como las siguientes:   ',
        changingTheCookieSettingsTitle:
          'MODIFICAR LA CONFIGURACIÓN DE LAS COOKIES',
        cookiePolicyTitle: 'POLÍTICA DE COOKIES',
        cookiesAffectedByTheRegulationText:
          'Según la directiva de la UE, las cookies que requieren el consentimiento informado por parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando exceptuadas las de carácter técnico y las necesarias para el funcionamiento del sitio web o la prestación de servicios expresamente solicitados por el usuario.',
        cookiesAffectedByTheRegulationTitle:
          'COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS',
        dependingOnThePurposeText1:
          'Cookies técnicas y funcionales:    son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan.',
        dependingOnThePurposeText2:
          'Cookies analíticas:    son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.',
        dependingOnThePurposeText3:
          'Cookies publicitarias:    son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.',
        dependingOnThePurposeText4:
          'Cookies de publicidad comportamental:    recogen información sobre las preferencias y elecciones personales del usuario (retargeting) para permitir la gestión, de la forma más 3eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado.',
        dependingOnThePurposeText5:
          'Cookies sociales:    son establecidas por las plataformas de redes sociales en los servicios para permitirle compartir contenido con sus amigos y redes. Las plataformas de medios sociales tienen la capacidad de rastrear su actividad en línea fuera de los Servicios. Esto puede afectar al contenido y los mensajes que ve en otros servicios que visita.',
        dependingOnThePurposeText6:
          'Cookies de afiliados:    permiten hacer un seguimiento de las visitas procedentes de otras webs, con las que el sitio web establece un contrato de afiliación (empresas de afiliación).',
        dependingOnThePurposeText7:
          'Cookies de seguridad:    almacenan información cifrada para evitar que los datos guardados en ellas sean vulnerables a ataques maliciosos de terceros.',
        dependingOnThePurposeTitle: 'SEGÚN LA FINALIDAD',
        informationAboutCookiesText:
          'Conforme con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio electrónico (LSSI), en relación con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos y Garantía de los Derechos Digitales (LOPDGDD), es obligado obtener el consentimiento expreso del usuario de todas las páginas web que usan cookies prescindibles, antes de que este navegue por ellas.',
        informationAboutCookiesTitle: 'INFORMACIÓN SOBRE COOKIES',
        processingOfPersonalDataText1:
          'MARSI BIONICS S.L es el Responsable del tratamiento de los datos personales del Interesado y le informa de que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril de 2016 (RGPD), por lo que se le facilita la siguiente información del tratamiento:   ',
        processingOfPersonalDataText2:
          'Fines del tratamiento:    según se especifica en el apartado de cookies que se utilizan en este sitio web.',
        processingOfPersonalDataText3:
          'Legitimación del tratamiento:    salvo en los casos en los que resulte necesario para la navegación por la web, por consentimiento del interesado (art. 6.1 RGPD).',
        processingOfPersonalDataText4:
          'Criterios de conservación de los datos:    según se especifica en el apartado de cookies utilizadas en la web.',
        processingOfPersonalDataText5:
          'Comunicación de los datos:    no se comunicarán los datos a terceros, excepto en cookies propiedad de terceros o por obligación legal.',
        processingOfPersonalDataTitle: 'TRATAMIENTO DE DATOS PERSONALES',
        rightsInterestedPartyText1:
          'Derecho a retirar el consentimiento en cualquier momento.',
        rightsInterestedPartyText2:
          'Derecho de acceso, rectificación, portabilidad y supresión de sus datos y a la limitación u oposición a su tratamiento.',
        rightsInterestedPartyText3:
          'Derecho a presentar una reclamación ante la Autoridad de control',
        rightsInterestedPartyText4:
          'si considera que el tratamiento no se ajusta a la normativa vigente.',
        rightsInterestedPartyText5:
          'Datos de contacto para ejercer sus derechos:   ',
        rightsInterestedPartyTitle: 'Derechos que asisten al Interesado:   ',
        typeOfCookiesTitle: 'TIPOS DE COOKIES',
        whatAreCookiesText1:
          'Las cookies y otras tecnologías similares tales como local shared objects, flash cookies o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.',
        whatAreCookiesText2:
          'Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos concernientes al usuario, como sus preferencias para la visualización de las páginas de ese servidor, nombre y contraseña, productos que más le interesan, etc.',
        whatAreCookiesTitle: '¿QUÉ SON LAS COOKIES?',
        whatCookiesDoWeUseText1:
          'A continuación, se presenta una explicación más detallada de cada tipo de cookie, su finalidad, tipo, temporalidad y titularidad:   ',
        whatCookiesDoWeUseText10: 'Propia',
        whatCookiesDoWeUseText11:
          'Uso de las cookies de Google Analytics en los sitios web:   ',
        whatCookiesDoWeUseText12:
          'Condiciones de privacidad de Google Analytics:   ',
        whatCookiesDoWeUseText13: 'Condiciones de las cookies de Google:   ',
        whatCookiesDoWeUseText14: 'COOKIES DE REDES SOCIALES',
        whatCookiesDoWeUseText15:
          'Adicionalmente, esta entidad tiene presencia en portales y servicios de terceros. Puede conocer sus condiciones de privacidad y uso de cookies consultando las políticas proporcionadas por los mismos:   ',
        whatCookiesDoWeUseText2:
          'Otras posibles cookies a cargar por el servicio de monitorización de visitas de Google.',
        whatCookiesDoWeUseText3: 'Finalidad',
        whatCookiesDoWeUseText4:
          'Generar un identificador de usuario único, que es el que se utiliza para hacer recuento de cuántas veces visita el sitio un usuario, así como la fecha de la primera y la última vez que visitó la web. Registrar la fecha y hora de acceso a cualquiera de las páginas del Sitio. Comprobar la necesidad de mantener la sesión de un usuario abierta o crear una nueva. Identificar la sesión del usuario, para recoger la ubicación geográfica aproximada del ordenador que accede al Sitio con efectos estadísticos.',
        whatCookiesDoWeUseText5: 'Tipo',
        whatCookiesDoWeUseText6: 'Analítica',
        whatCookiesDoWeUseText7: 'Temporalidad',
        whatCookiesDoWeUseText8: 'Permanente / Temporal',
        whatCookiesDoWeUseText9: 'Titularidad',
        whatCookiesDoWeUseTitle: '¿QUÉ COOKIES UTILIZAMOS Y PARA QUÉ?',
      },
      
      history: {
        history:'Histórico',
        patientHistory:'Históricos del Paciente',
        medicalHistory:'Datos Médicos',
        explorerHistory:'Explorer',
        atlasHistory:'Atlas',
        loadingHistory: 'Cargando...',
        loadingError: 'Error al cargar el histórico',
        noData: 'Sin datos'
      },

      country: 'País',
      countryInvalid: 'País inválido',
      countryInvalidCharacters: 'País contiene caracteres inválidos',
      countryRequired: 'País es requerido',
      deviceCode: 'Código de dispositivo',
      deviceCodeInvalid: 'Código de dispositivo inválido',
      deviceCodeRequired: 'Código de dispositivo es requerido',
      devices: 'Dispositivos',
      dividerPrivateOrClinician: 'Profesional o Particular',
      email: 'Email (No se podrá cambiar)',
      emailInvalid: 'Email inválido',
      emailRequired: 'Email es requerido',
      getInstitutionName:
        'Por favor, introduce el código de dispositivo para que podamos localizar la organización dónde trabajas',
      goTooltipLogin: 'Ir a inicio de sesión',
      goTooltipRecoverPassword: 'Ir a recuperar contraseña',
      institution: 'Código de dispositivo',
      institutionInvalid: 'Organización inválida',
      institutionName: 'Nombre de la Organización',
      institutionRequired: 'Organización es requerida',
      intitutionNotFound:
        'Lo sentimos, no hemos podido encontrar la organización con el código proporcionado...',
      invalidCharactersName: 'Nombre contiene caracteres inválidos',
      invalidCharactersNationality:
        'Nacionalidad contiene caracteres inválidos',
      invalidCharactersSurnames: 'Apellidos contiene caracteres inválidos',
      invalidName: 'Nombre inválido',
      invalidNationality: 'Nacionalidad inválida',
      invalidSurnames: 'Apellidos inválidos',
      isClinic: 'Soy profesional',
      isParticular: 'Soy particular',
      legalNotice: 'el aviso legal',
      legalNoticeTexts: {
        address: 'Domicilio:   ',
        applicableLawAndJurisdictionText:
          'La relación entre MARSI BIONICS S.L y el usuario se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Rivas-Vaciamadrid.',
        applicableLawAndJurisdictionTitle:
          'LEGISLACIÓN APLICABLE Y JURISDICCIÓN:   ',
        applicableLegislationText:
          'El presente Aviso Legal se rige en todos y cada uno de sus extremos por la legislación española.',
        applicableLegislationTitle: 'LEGISLACIÓN APLICABLE:   ',
        book: 'Libro:   ',
        cif: 'CIF:   ',
        companyName: 'Razón Social:   ',
        date: 'Fecha:   ',
        domainName: 'Nombre del dominio:   ',
        email: 'Correo Electrónico:   ',
        europeanPlatformText:
          'Le informamos que ante cualquier problema que pueda derivarse del servicio contratado o producto vendido, puede utilizar la plataforma europea de resolución de disputas online:   ',
        europeanPlatformTitle:
          'PLATAFORMA EUROPEA DE RESOLUCIÓN DE CONFLICTOS EN LÍNEA:   ',
        exclusionWarrantiesText1:
          'MARSI BIONICS S.L. no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo:    errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.',
        exclusionWarrantiesText2:
          'El contenido, información y/o consejos expresados en este portal web deben entenderse como simplemente orientativos. MARSI BIONICS S.L no responde de ninguna forma de la efectividad o exactitud de los mismos, quedando exenta de cualquier responsabilidad con los usuarios que haga uso de ellos, ya que son éstas las que deberán decidir según su criterio la oportunidad de los mismos. En este Sitio se pueden publicar contenidos y comentarios aportados por terceras personas. MARSI BIONICS S.L. no responde de la veracidad y exactitud de los mismos, quedando exenta de cualquier responsabilidad con los usuarios que hagan uso de ellos.',
        exclusionWarrantiesText3:
          'MARSI BIONICS S.L. se reserva el derecho de modificar el contenido del Sitio sin previo aviso y sin ningún tipo de limitación. Así mismo la empresa declina cualquier responsabilidad por los eventuales daños y perjuicios que puedan ocasionarse por la falta de disponibilidad y/o continuidad de este Sitio y de los servicios que se ofrecen en él. Así mismo, tampoco podemos garantizar la ausencia de virus ni de otros elementos en la Web que puedan producir alteraciones en su sistema informático.',
        exclusionWarrantiesText4:
          'MARSI BIONICS S.L. declina cualquier responsabilidad por los servicios y/o información que se preste en otros sitios enlazados con este, ya que no controla ni ejerce ningún tipo de supervisión en Sitios Webs de terceros. Aconsejamos a los usuarios de los mismos a actuar con prudencia y consultar las eventuales condiciones legales que se expongan en dichas Webs. Así mismo los Usuarios que remitan cualquier tipo de información a MARSI BIONICS S.L se comprometen a que la misma sea veraz y que no vulnere cualquier derecho de terceros ni la legalidad vigente.',
        exclusionWarrantiesText5:
          'Si Ud. cree que cualquier contenido y/o información de este Sitio vulnera un derecho legítimo o la legalidad vigente le agradeceríamos que se pusiera en contacto con MARSI BIONICS S.L. a través del correo electrónico',
        exclusionWarrantiesText6:
          'para que podamos tomar las medidas oportunas.',
        exclusionWarrantiesTitle:
          'EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD:   ',
        generalText:
          'MARSI BIONICS S.L perseguirá el incumplimiento de las presentes condiciones, así como cualquier utilización indebida de su portal ejerciendo todas las acciones civiles y penales que le puedan corresponder en derecho.',
        generalTitle: 'GENERALIDADES:   ',
        identificationData: 'DATOS IDENTIFICATIVOS:   ',
        intellectualPropertyText1:
          'MARSI BIONICS S.L, por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo, imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.), todos los derechos reservados.',
        intellectualPropertyText2:
          'En virtud de lo dispuesto en los artículos 8 y 32.1, párrafo segundo, de la Ley de Propiedad Intelectual, quedan expresamente prohibidas la reproducción, la distribución y la comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización de MARSI BIONICS S.L. En ningún momento, salvo manifestación expresa de lo contrario, el acceso, navegación o utilización del sitio Web o de sus contenidos confiere al usuario derecho alguno sobre signos distintivos en él incluidos. El usuario se compromete a respetar los derechos de Propiedad Intelectual e Industrial titularidad de MARSI BIONICS S.L. La utilización no autorizada de la información contenida en este Sitio, así como los perjuicios ocasionados en los derechos de propiedad intelectual e industrial de MARSI BIONICS S.L pueden dar lugar al ejercicio de las acciones que legalmente correspondan y, si procede, a las responsabilidades que de dicho ejercicio se deriven.',
        intellectualPropertyText3:
          'En el caso de que la usuaria o el usuario envíe información de cualquier tipo a MARSI BIONICS S.L a través de cualquiera de los canales habilitados para ello dentro de nuestro portal web, la usuaria o el usuario declara, garantiza y acepta que tiene derecho a hacerlo con total libertad, que dicha información no infringe ningún derecho de propiedad intelectual, industrial, o cualesquiera otros derechos de terceras personas, y que dicha información no tiene carácter confidencial ni es perjudicial para terceras personas.',
        intellectualPropertyTitle: 'PROPIEDAD INTELECTUAL E INDUSTRIAL:   ',
        legalNoticeTitle: 'Aviso Legal',
        modificationsText:
          'MARSI BIONICS S.L se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados en su portal.',
        modificationsTitle: 'MODIFICACIONES:   ',
        page: 'Folio:   ',
        phone: 'Teléfono:   ',
        registry: 'Inscrita en el Registro:   ',
        rightOfExclusionText:
          'MARSI BIONICS S.L se reserva el derecho a denegar o retirar el acceso a portal y/o los servicios ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que incumplan las presentes Condiciones Generales de Uso.',
        rightOfExclusionTitle: 'DERECHO DE EXCLUSIÓN:   ',
        section: 'Sección:   ',
        sheet: 'Hoja:   ',
        text2IdentificationData: 'El titular del presente sitio es:   ',
        textIdentificationData:
          'En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación, se reflejan los siguientes datos:   ',
        textLegalNotice:
          ' El presente documento tiene como finalidad el establecer y regular las normas de uso de este portal web, entendiendo por éste todas las páginas y sus contenidos propiedad de MARSI BIONICS S.L. a las cuales se accede a través del dominio www.marsinet.com. La utilización del portal web atribuye la condición de usuario de este e implica la aceptación de todas las condiciones incluidas en el presente Aviso Legal. El usuario se compromete a leer atentamente el presente Aviso Legal en cada una de las ocasiones en que se proponga utilizar nuestro portal web ya que éste y sus condiciones de uso recogidas en el presente Aviso Legal pueden sufrir modificaciones.',
        tome: 'Tomo:   ',
        usePortalText:
          'Este portal proporciona el acceso a un análisis de los datos recopilados tras el uso de alguno de los dispositivos comercializados por Marsi Bionics. El usuario asume la responsabilidad del uso del portal. Dicha responsabilidad se extiende al registro o recogida de datos que fuese necesaria para acceder a determinados servicios. En dicho registro el usuario será responsable de aportar información veraz y lícita.',
        usePortalTitle: 'USO DEL PORTAL:   ',
        usersText:
          'El acceso y/o uso de este portal web atribuye la condición de USUARIO, que acepta, desde dicho acceso y/ o uso, las Condiciones Generales de Uso aquí reflejadas. Las citadas Condiciones serán de aplicación independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.',
        usersTitle: 'USUARIOS:   ',
      },
      myHome: 'Mi Hogar',
      myInstitution: 'Mi organización',
      myProfile: 'Mi cuenta',
      name: 'Nombre',
      nameOrganizationInvalid: 'Nombre de la organización inválido',
      nameOrganizationInvalidCharacters:
        'Nombre de la organización contiene caracteres inválidos',
      nameOrganizationInvalidMarsi:
        'Nombre de la organización inválido, no puede contener "Marsi"',
      nameRequired: 'Nombre es requerido',
      nameTooShort: 'El nombre debe tener al menos 2 caracteres',
      nationality: 'Nacionalidad',
      nationalityRequired: 'Nacionalidad es requerida',
      number: 'Número',
      o_id: 'Código de organización',
      optional: 'Los campos marcados con este símbolo son obligatorios.',
      or: 'O',
      organizationRequired: 'Organización es requerida',
      particular: 'Particular',
      password: 'Contraseña',
      passwordLowercase: 'Debe contener al menos una letra minúscula',
      passwordMin: 'La contraseña debe tener al menos 8 caracteres',
      passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
      passwordNotCommon:
        'La contraseña no puede ser una palabra común o fácilmente adivinable',
      passwordNumber: 'Debe contener al menos un número',
      passwordRequired: 'Contraseña es requerida',
      passwordSpecial: 'Debe contener al menos un caracter especial',
      passwordUppercase: 'Debe contener al menos una letra mayúscula',
      phone: 'Teléfono',
      phoneInvalid: 'Teléfono inválido (ejemplo:    +34600000000)',
      phoneInvalidCharacters: 'Teléfono contiene caracteres inválidos',
      phoneRequired: 'Teléfono es requerido',
      pickPassword: 'Introduce tu contraseña',
      postalCode: 'Código Postal',
      postalCodeInvalid: 'Código postal inválido',
      postalCodeRequired: 'Código postal es requerido',
      postal_codeInvalid: 'Código postal inválido',
      postal_codeInvalidCharacters:
        'Código postal contiene caracteres inválidos',
      postal_codeRequired: 'Código postal es requerido',
      privacyPoliceTexts: {
        accuracyVeracityText:
          'Como usuario, es usted el único responsable de la veracidad y corrección de los datos que nos remita, exonerando a MARSI BIONICS S.L de cualquier responsabilidad al respecto. Los usuarios garantizan y responden, en cualquier caso, de la exactitud, vigencia y autenticidad de los datos personales facilitados, y se comprometen a mantenerlos debidamente actualizados.',
        accuracyVeracityTitle: 'EXACTITUD Y VERACIDAD DE LOS DATOS',
        additionalInformationText1:
          'Si necesita información adicional sobre protección de datos, puede enviarnos un correo electrónico a ',
        additionalInformationText2:
          ' o una comunicación dirigida a Calle Marie Curie, 13, Edif. Bioma, Planta 6, Oficinas 1-2, CP 28521 Rivas-Vaciamadrid, Madrid y, en función del tipo de relación que tenga con nuestra entidad y el tratamiento de datos personales que realicemos, le facilitaremos la información adicional que corresponda.',
        additionalInformationTitle:
          'INFORMACIÓN ADICIONAL SOBRE PROTECCIÓN DE DATOS',
        address: 'Domicilio:   ',
        changesPrivacyPoliceText:
          'MARSI BIONICS S.L se reserva el derecho a modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria. En dichos supuestos, anunciará en esta página los cambios introducidos con razonable antelación a su puesta en práctica.',
        changesPrivacyPoliceTitle: 'CAMBIOS EN LA POLÍTICA DE PRIVACIDAD',
        cif: 'CIF:   ',
        companyName: 'Razón Social:   ',
        dataConfidentialityText1:
          'MARSI BIONICS S.L se compromete al uso y tratamiento de los datos personales del usuario, respetando su confidencialidad, de acuerdo con la finalidad de aquellos; así como a dar cumplimiento a su obligación de guardarlos y adoptar todas las medidas para evitar la alteración, pérdida, tratamiento o acceso no autorizado, de conformidad con lo establecido en la normativa vigente de protección de datos.',
        dataConfidentialityText2:
          'MARSI BIONICS S.L no puede garantizar la absoluta inexpugnabilidad de Internet, ni, por tanto, la violación de los datos mediante accesos fraudulentos a ellos por parte de terceros. Con respecto a la confidencialidad del procesamiento, MARSI BIONICS S.L se asegurará de que cualquier persona que esté autorizada por MARSI BIONICS S.L para procesar los datos del cliente (incluido su personal, colaboradores y prestadores), se encuentre bajo la debida obligación de confidencialidad (ya sea un deber contractual o legal).',
        dataConfidentialityTitle: 'SECRETO Y SEGURIDAD DE LOS DATOS',
        dataProcessingText:
          'El tratamiento, la comunicación y la cesión de los datos de carácter personal recogidos en esta página web se ajustará a lo dispuesto en la normativa de protección de datos de carácter personal, y en particular, con la ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, y, el actual Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE.',
        dataProcessingTitle: 'Procesamiento de datos',
        email: 'Correo Electrónico:   ',
        howLongWillWeProcessText1:
          'Los datos personales que nos proporciones serán conservados mientras se mantenga la relación contractual / mercantil vigente, o bien durante un plazo de cuatro años a partir de la última relación negocial, siguiendo la normativa a efectos fiscales.',
        howLongWillWeProcessText2:
          'Posteriormente, los datos serán suprimidos conforme a lo dispuesto en la normativa de protección de datos lo que implica su bloqueo, estando disponibles tan sólo a solicitud de Jueces y Tribunales, el Ministerio Fiscal o las Administraciones Públicas competentes durante el plazo de prescripción de las acciones que pudieran derivar y, transcurrido éste, serán eliminados por completo.',
        howLongWillWeProcessText3:
          'Siempre podrá ejercitar los derechos que le reconoce la normativa vigente poniéndose en contacto a través de la vía que le sea más cómoda, ya sea a través del correo electrónico',
        howLongWillWeProcessText4:
          ', o del teléfono 914 90 00 90 o en la dirección postal Marie Curie 13, Planta 6, Edif. Bioma, Oficinas 1-2, 28521 Rivas-Vaciamadrid, Madrid.',
        howLongWillWeProcessTitle:
          '¿Durante cuánto tiempo trataremos sus datos?',
        personalDataThirdPartiesText1:
          'En el caso de que los datos personales aportados pertenecieran a un tercero, como usuario usted garantiza que ha informado a dicho tercero de esta Política de Privacidad y ha obtenido su autorización para facilitar sus datos a MARSI BIONICS S.L con las finalidades señaladas.',
        personalDataThirdPartiesText2:
          'Igualmente, usted garantiza que los datos aportados son exactos y actualizados, siendo responsable de cualquier daño o perjuicio, directo o indirecto, que pudiera ocasionarse como consecuencia del incumplimiento de tal obligación.',
        personalDataThirdPartiesTitle: 'DATOS PERSONALES DE TERCEROS',
        phone: 'Teléfono:   ',
        pivacyPoliceText:
          'De conformidad con lo dispuesto en el Reglamento UE 2016/679, del Parlamento Europeo y del Consejo del 27 de abril de 2016 (RGPD) y la Ley Orgánica 3/2018, del 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales, MARSI BIONICS S.L, te informa de que, mediante la aceptación de esta Política de Privacidad, prestas tu consentimiento expreso, informado, libre e inequívoco para que los datos que proporcionas, y sobre los que se aplican las medidas de seguridad, técnicas y organizativas previstas en la normativa vigente, sean tratados por MARSI BIONICS S.L, como responsable del tratamiento. Los datos de carácter personal que pudiésemos recabar directamente del interesado a través de www.marsinet.com serán tratados de forma confidencial y quedarán incorporados a la correspondiente actividad de tratamiento titularidad de MARSI BIONICS S.L.',
        pivacyPoliceTitle: 'POLÍTICA DE PRIVACIDAD',
        responsability:
          'Responsable de Seguridad o Delegado de Protección de Datos en su caso:   ',
        securityBreachNotificationText:
          'En MARSI BIONICS S.L asumimos medidas de seguridad adecuadas al nivel de riesgo para proteger la información personal contra la pérdida, el uso indebido y el acceso no autorizado, su divulgación, alteración y destrucción, teniendo en cuenta los riesgos que conlleva el procesamiento y la naturaleza de la información personal; no obstante, si MARSI BIONICS S.L determina que los datos personales que trata han sido malversados, se han visto expuestos por una brecha de seguridad o adquiridos de forma incorrecta por un tercero, MARSI BIONICS S.L actuará de forma inmediata teniendo en cuenta lo establecido por el RGPD y las autoridades de protección de datos competentes.',
        securityBreachNotificationTitle:
          'NOTIFICACIÓN Y DECLARACIÓN DE BRECHAS DE SEGURIDAD',
        whatDataProcessText1:
          'En el marco de la prestación de los servicios que ofrece la entidad y condicionado a las finalidades consentidas por usted, nuestra entidad únicamente se tratarán los datos estrictamente necesarios para la correcta gestión de la relación contractual y/o prestación de los servicios, y será exclusivamente los que usted nos haya facilitado.',
        whatDataProcessText2: 'Datos recopilados:   ',
        whatDataProcessText3:
          'Datos identificativos:    nombre, apellidos, fecha de nacimiento, nacionalidad, empresa.',
        whatDataProcessText4:
          'Datos de contacto:    dirección postal, correo electrónico, número de teléfono móvil, documento de identidad.',
        whatDataProcessText5:
          'Datos fisiológicos y de salud:    sexo, peso, altura, patología, tratamiento.',
        whatDataProcessText6:
          'Datos navegación:    dirección IP, tipo e identificación del dispositivo, tipo de navegador, dominio a través del cual accede al Sitio Web, datos de navegación, actividad en el Sitio Web.',
        whatDataProcessText7:
          '* Más aquellos datos que se recogen del uso del dispositivo (número de pasos, fuerza en las articulaciones, rango articular…).',
        whatDataProcessTitle: '¿Qué datos tratamos?',
        whatLegitimateBasisText1:
          'La base legal para el tratamiento de sus datos es:   ',
        whatLegitimateBasisText2:
          'La ejecución de un contrato con MARSI BIONICS S.L, para la contratación de servicios y/o productos y gestionar los servicios solicitados.',
        whatLegitimateBasisText3:
          'El consentimiento del usuario en relación al contacto, la suscripción a contenidos y el envío de comunicaciones comerciales, vía mail, cookies o sistemas de mensajería.',
        whatLegitimateBasisText4:
          'El interés legítimo del responsable del tratamiento para proteger a los usuarios de la web de MARSI BIONICS S.L de abusos y fraudes en el uso de nuestros servicios.',
        whatLegitimateBasisTitle:
          '¿Cuál es la base de legitimación para el tratamiento de sus datos?',
        whatPurposesDoWeProcessText1:
          'Los datos personales que aparecen en esta página web son extraídos de alguno de los productos y/o aplicaciones de Marsi Bionics utilizadas por el usuario.',
        whatPurposesDoWeProcessText2:
          'La finalidad del tratamiento de estos datos es representar los resultados obtenidos tras el uso del dispositivo o aplicación. Estos datos podrán ser consultados por el propio usuario y/o por el personal clínico encargado del seguimiento de sus datos.',
        whatPurposesDoWeProcessText3:
          'El personal técnico de MARSI BIONICS tendrá acceso a los datos de uso del dispositivo para velar por su correcto estado de mantenimiento.',
        whatPurposesDoWeProcessTitle:
          '¿Con qué finalidad tratamos sus datos personales?',
        whatYoursRightsText1:
          'Cualquier persona tiene derecho a obtener confirmación sobre si estamos tratando datos personales que les conciernan o no. En este sentido, usted tiene derecho a solicitar:   ',
        whatYoursRightsText10:
          'Será necesario aportar fotocopia del DNI o documento equivalente que acredite la identidad y sea considerado válido en derecho, en aquellos supuestos en que el responsable del tratamiento tenga dudas sobre su identidad.',
        whatYoursRightsText11:
          'Si desea obtener información adicional respecto al ejercicio de sus derechos, también puede dirigirse a la Agencia Española de Protección de Datos.',
        whatYoursRightsText12:
          'Asimismo, le informamos que, si lo cree oportuno, tiene el derecho a retirar, en cualquier momento, el consentimiento otorgado para alguna finalidad específica, sin que ello afecte a la licitud del tratamiento, basado en el consentimiento previo a su retirada. En caso de que entendiera que no se han atendido adecuadamente sus derechos, podrá presentar una reclamación ante la Agencia Española de Protección de Datos. C/ Jorge Juan, 6. 28001 – Madrid.',
        whatYoursRightsText2:
          'Acceso.- El interesado tendrá derecho a obtener del responsable del tratamiento confirmación de si se están tratando o no los datos que le conciernan, así como información detallada acerca de determinados aspectos del tratamiento que se esté llevando a cabo.',
        whatYoursRightsText3:
          'Rectificación.- El interesado tendrá derecho a obtener la rectificación de los datos personales inexactos que le concierne o que se completen aquellos que fueran incompletos.',
        whatYoursRightsText4:
          'Supresión.- El interesado tendrá derecho a solicitar la supresión de sus datos personales, en todo caso la supresión estará sujeta a los límites establecidos en la norma reguladora.',
        whatYoursRightsText5:
          'Limitación de su tratamiento.- El interesado tendrá derecho a solicitar la limitación respecto al tratamiento de sus datos de carácter personal',
        whatYoursRightsText6:
          'Oposición al tratamiento.- En determinadas circunstancias y por motivos relacionados con su situación particular, los interesados podrán oponerse al tratamiento de sus datos. La entidad dejará de tratar los datos, salvo por motivos legítimos, imperiosos, o el ejercicio o la defensa de posibles reclamaciones.',
        whatYoursRightsText7:
          'Derecho a la portabilidad de sus datos.- Es decir, tendrá derecho a recibir los datos personales que le incumban, que haya facilitado a un responsable del tratamiento, en un formato estructurado, de uso común y lectura mecánica y a transmitirlos a otro responsable del tratamiento.',
        whatYoursRightsText8:
          'Podrá ejercer los referidos derechos, dirigiéndose al responsable a través del correo electrónico soporte.marsinet@marsibionics.com o del teléfono 914 90 00 90. Los formularios para el ejercicio de derechos también pueden ser presentados presencialmente o enviados por carta a la dirección postal Marie Curie 13, Planta 6, Edif. Bioma, Oficinas 1-2, 28521 Rivas-Vaciamadrid, Madrid.',
        whatYoursRightsText9:
          'En caso de que se actúe a través de representación legal, deberá aportar, además, DNI y documento acreditativo de la representación del representante.',
        whatYoursRightsTitle:
          '¿Cuáles son sus derechos cuando nos facilita sus datos?',
        whichRecipientsDataCommunicatedText1:
          'Le informamos que no se realizarán transferencias internacionales.',
        whichRecipientsDataCommunicatedText2:
          'Se informa al Usuario de que, para la correcta prestación de los servicios (véase, alojamiento web, soporte, email marketing, etc.), distintos prestadores de servicios contratados por nuestra entidad (encargados del tratamiento) podrían tener acceso a la información personal necesaria para realizar sus funciones.',
        whichRecipientsDataCommunicatedText3:
          'Estos servicios prestados por terceros son necesarios para el desarrollo de nuestra actividad y, en todo momento, el tratamiento de los datos que lleven a cabo se rige por un contrato que vincula al encargado respecto a nuestra entidad. En ningún caso utilizarán la información para otros fines y la tratarán de conformidad con las directrices estipuladas por nuestra entidad, acordes a su política de privacidad y a la normativa vigente en materia de protección de datos.',
        whichRecipientsDataCommunicatedText4:
          'Nuestra entidad en su compromiso con la privacidad y protección de datos del Usuario, elegirá únicamente prestadores de servicio que ofrezcan las garantías suficientes para aplicar medidas técnicas y organizativas apropiadas, de manera que el tratamiento sea conforme la legislación aplicable en materia de protección de datos y garanticen la protección de los derechos del Usuario.',
        whichRecipientsDataCommunicatedTitle:
          '¿A qué destinatarios se comunicarán sus datos?',
        whoDataControllerTitle:
          '¿Quién es el Responsable del tratamiento de sus datos?',
      },
      prefix: 'Prefijo',
      province: 'Provincia',
      provinceRequired: 'Provincia es requerida',
      role: 'Rol',
      roleRequired: 'Rol es requerido',
      selectCountry: 'Seleccione país',
      state: 'Provincia',
      stateRequired: 'Provincia es requerida',
      streetNameRequired: 'Nombre de calle es requerido',
      streetNumberInvalid: 'Número de calle inválido',
      streetNumberRequired: 'Número de calle es requerido',
      street_nameInvalid: 'Nombre de calle inválido',
      street_nameInvalidCharacters:
        'Nombre de calle contiene caracteres inválidos',
      street_nameRequired: 'Nombre de calle es requerido',
      street_numberInvalid: 'Número de calle inválido',
      street_numberInvalidCharacters:
        'Número de calle contiene caracteres inválidos',
      street_numberRequired: 'Número de calle es requerido',
      submit: 'Registrarse',
      suggestion: 'Sugerencia',
      suggestionLetterLower: 'Una letra minúscula',
      suggestionLetterUpper: 'Una letra mayúscula',
      suggestionMinLength: 'Al menos 8 caracteres',
      suggestionNumber: 'Al menos un número',
      suggestionSpecial: 'Al menos un caracter especial',
      surnames: 'Apellidos',
      surnamesRequired: 'Apellidos es requerido',
      surnamesTooShort: 'Los apellidos deben tener al menos 2 caracteres',
      title: 'Formulario de Registro',
      tooltipIsClinic:
        'Voy a hacer un uso del dispositivo en una organización clínica con más de un usuario.',
      tooltipIsParticular:
        'Voy a hacer uso del dispositivo de manera individual, solo lo utilizará un único usuario',
      user: 'Datos del usuario',
      birthDateNotAdult: 'El usuario debe ser mayor de edad',
    },
    reports: {
      birthDate: 'Fecha de nacimiento',
      comments: 'Comentarios / Hallazgos',
      createAt: 'Creado el',
      description: 'Descripción',
      diagnostic: 'Diagnóstico',
      firstUseDevice: 'Primer uso del dispositivo',
      followUpReport: 'Reporte de seguimiento',
      goBack: 'Volver atrás',
      graphs: {
        timeHour: 'Hora',
        fc: 'Frecuencia cardiaca',
        so2: 'Saturación de oxígeno',
        rom: 'ROM',
        stepsByMode: 'Total de pasos por modo',
        automaticBackward: 'Automático atrás',
        automaticForward: 'Automático adelante',
        automaticForwardTime: 'Automático adelante',
        forwardIntention: 'Activación por fuerza adelante',
        backwardIntention: 'Activación por fuerza atrás',
        ann1Forward: 'Aan1 adelante',
        ann1Backward: 'Aan1 atrás',
        ann2Forward: 'Aan2 adelante',
        ann2Backward: 'Aan2 atrás',
        activeMode: 'Modo activo',
        activeModeForward: 'Modo activo adelante',
        activeModeBackward: 'Modo activo atrás',
        dailyEvolutionOfTheScore: 'Evolución de la puntuación diaria',
        dayAndMode: 'Pasos por día y modo',
        days: 'Días',
        distributionStepsLastDay:
          'Distribución de los pasos realizados en la última sesión',
        evolutionOfTheScore: 'Evolución mensual de la puntuación',
        mobile:
          'El contenido de los gráficos no es visible en dispositivos móviles, por favor acceda desde un ordenador o un dispositivo mas grande para visualizarlos.',
        percentage: 'Porcentaje (%)',
        percentageAnalysis: 'Análisis porcentual',
        score: 'Puntuación',
        sessions: 'Sesiones',
        steps: 'Pasos',
        time: 'Minutos',
        totalSteps: 'Cantidad total de pasos',
        totalTime: 'Cantidad total de tiempo',

      },
      identificationNumber: 'Número de identificación',
      lastSessionReceived: {
        score: 'ha sido la puntuación total de la sesión',
        standing: 'de tiempo de pie en la última sesión',
        steps: 'pasos',
        time: 'de tiempo usando el dispositivo en la última sesión',
        timeMeasurement: 'minutos ',
        title: 'Última sesión recibida',
        totalSteps: 'En la última sesión ha dado una cantidad de',
        walking: 'de tiempo caminando en la última sesión',
      },
      lastUseDevice: 'Último uso del dispositivo',
      nameSurname: 'Nombre y apellidos',
      patientData: 'Datos del paciente',
      performed: 'realizados',
      romTitle: 'Rango de movimiento (ROM)',
      saveToPdf: 'Guardar como PDF',
      score: 'Puntuación',
      sessionSummary: 'Resumen de sesión',
      sessionsHeldInception: {
        score: 'ha sido la puntuación total histórica',
        sessions: 'sesiones',
        steps: 'pasos dados desde el día',
        time: 'de tiempo usando el dispositivo durante',
        timeMeasurement: 'minutos',
        title: 'Sesiones realizadas desde el inicio',
      },
      sessionsLastMonth: {
        score: 'ha sido la puntuación total mensual',
        sessions: 'sesiones',
        steps: 'pasos dados hasta el día',
        theLastMonth: 'en el último mes',
        time: 'de tiempo usando el dispositivo durante',
        timeMeasurement: 'minutos',
        title: 'Sesiones realizadas en el último mes',
      },
      signedBy: {
        certificate: '¿Número de certificado en ATLAS?',
        nameSurname: 'Nombre y Apellidos',
        registrationNumber: 'Número de colegiado',
      },
      steps: 'Pasos',
      tables: {
        ankle: 'Tobillo',
        anklel: 'Tobillo izquierdo',
        ankler: 'Tobillo derecho',
        automatic: 'Automático',
        backward: 'Atrás',
        cadence: 'Cadencia',
        cadenceAutomatic: 'Cadencia automática',
        cadenceIntention: 'Cadencia en intención',
        dungarees: 'Peto',
        effort: 'Esfuerzo',
        flexos: 'Flexos',
        forward: 'Adelante',
        hip: 'Cadera',
        hipl: 'Cadera izquierda',
        hipr: 'Cadera derecha',
        history: 'Histórico (promedios)',
        index: 'Índice',
        intention: 'Activación por fuerza',
        knee: 'Rodilla',
        kneel: 'Rodilla izquierda',
        kneer: 'Rodilla derecha',
        lastMonth: 'Último mes (promedios)',
        lastSession: 'Última sesión',
        result: 'Resultado',
        stepsAutomatic: 'Pasos automáticos',
        stepsIntention: 'Pasos con intención hacia',
        tableComparativeOfLastSessionTitle:
          'Tabla comparativa de los datos de la última sesión con respecto a los históricos y últimos mensuales',
        therapist: 'Terapeuta',
        threshold: 'Umbral',
        titleLastSessions:
          'Tabla de puntuación con los datos de la última sesión',
        total: 'Total',
      },
      targets: 'Objetivos',
      time: 'Tiempo',
      torqueTitle: 'Fuerza aplicada por articulación',
      totalNumberofSessionsWithDevice:
        'Número total de sesiones con el dispositivo',
      totalSteps: 'Distribución de pasos por modo y dirección (%)',
      totalTime: 'Tiempo total de uso',
      yourResults: 'Estos son tus resultados históricos',
    },
    requestResetPassword: {
      back: 'Ir a inicio de sesión',
      email: 'Email',
      emailInvalid: 'Email inválido',
      emailRequired: 'Email es requerido',
      emailSent: 'Email enviado',
      emailSentError: 'Error al enviar el email',
      emailSentSuccess: 'Email enviado correctamente',
      messageSent:
        'Te hemos enviado las instrucciones para restablecer tu contraseña a tu dirección de correo electrónico.',
      send: 'Enviar',
      title: 'Restablecer contraseña',
    },
    pendingSurveys: {
      title: 'Encuestas pendientes',
      loading: 'Cargando...',
      noPendingSurveys: 'No hay encuestas pendientes',
      priority: {
        mandatory: 'Obligatoria',
        optional: 'Opcional',
      },
      requestLoading: 'Cargando encuesta...',
      daysLeftUnit: 'días',
      selectRequest: 'Seleccione una opción',
      yes: 'Sí',
      no: 'No',
      anonymizeYourAnswers: '¿Quieres que esta encuesta sea anónima?',
      anonymizeAllYourAnswers: 'Esta encuesta es anónima',
      close: 'Salir sin guardar',
      table: {
        name: 'Nombre de la encuesta',
        daysLeft: 'Días restantes',
        dueDate: 'Fecha límite',
        description: 'Descripción',
        priority: 'Tipo de encuesta',
        status: 'Estado',
      },
      send: 'Enviar',
      noSurveyLoaded: 'No se ha podido cargar la encuesta',
      anonimizationYes: 'Esta respuesta se anonimizará completamente.',
      confirmSubmitHeader: '¿Estás seguro de que quieres enviar esta encuesta?',
      confirmSubmitMessage:
        'No podrás editar tus respuestas después de enviarla',
      saveDraft: 'Guardar borrador',
      draftOngoing: 'Borrador en curso',
      exitConfirmHeader: 'Cambios sin guardar',
      exitConfirmMessage:
        'Tienes cambios sin guardar. ¿Quieres guardarlos como borrador antes de salir?',
      exitWithoutSaving: 'Salir sin guardar',
      saveDraftAndExit: 'Guardar borrador y salir',
      tabs: {
        pending: 'Encuestas pendientes',
        previous: 'Respuestas anteriores',
      },
      previous: {
        empty: 'Aún no has respondido ninguna encuesta',
        survey: 'Encuesta',
        answerNumber: 'N.º de respuesta',
        anonymized: 'Anonimizada',
        date: 'Fecha',
        detailTitle: 'Detalle de la respuesta',
      },
    },
    sessions: {
      add: 'Nueva sesión',
      eventsList: 'Listado de eventos',
      incidentList: 'Listado de incidencias',
      numberOfSteps: 'Número de pasos',
      sessions: 'Uso del dispositivo',
      table: {
        actions: 'Acciones',
        date: 'Fecha',
        filters: {
          date: 'Fecha...',
          name: 'Nombre...',
          surnames: 'Apellidos...',
        },
        name: 'Nombre',
        surnames: 'Apellidos',
      },
      timeOfUse: 'Tiempo de uso',
      title: 'Listado sesiones',
    },
    users: {
      titlePassword: 'Restablecer contraseña',
      resetPasswordConfirm:
        'Se enviará un email de restablecimiento a {{email}}. ¿Continuar?',
      temporaryPassword: 'Contraseña temporal',
      descriptionTemporaryPassword:
        'Se generará una contraseña temporal para {{email}}. Solo se mostrará una vez. Debe restablecer la contraseña después . ¿Continuar?',
      add: 'Crear usuario',
      birthDate: 'Fecha de nacimiento',
      birth_date_required: 'Fecha de nacimiento es requerida',
      city: 'Ciudad',
      city_required: 'Ciudad es requerida',
      country: 'País',
      country_required: 'País es requerido',
      createUser: {
        birth_dateRequired: 'Fecha de nacimiento es requerida',
        cityRequired: 'Ciudad es requerida',
        countryRequired: 'País es requerido',
        data: 'Datos del usuario',
        device: 'Dispositivo',
        devices: 'Dispositivos',
        emailInvalid: 'Email inválido',
        emailRequired: 'Email es requerido',
        institution: 'Organización',
        nameRequired: 'Nombre es requerido',
        nationalityRequired: 'Nacionalidad es requerida',
        organization_idRequired: 'ID Organización es requerido',
        passwordRequired: 'Contraseña es requerida',
        phoneRequired: 'Teléfono es requerido',
        postal_codeRequired: 'Código Postal es requerido',
        roleRequired: 'Tipo de Usuario es requerido',
        stateRequired: 'Provincia es requerida',
        street_nameRequired: 'Dirección es requerida',
        street_numberRequired: 'Número es requerido',
        surnamesRequired: 'Apellidos es requerido',
        type: 'Tipo de usuario',
        type_device_required: 'Tipo de usuario es requerido',
      },
      delete: 'Eliminar',
      deleteConfirm: '¿Estás seguro que deseas eliminar el usuario?',
      deleteConfirmTitle: 'Confirmación de eliminación',
      deleteError:
        'Error al eliminar el usuario. Comprueba si el usuario no esté en PENDIENTE de verificación',
      cannotDeletePendingUser:
        'No se puede eliminar un usuario que esté en estado PENDIENTE DE VERIFICACIÓN',
      missingIdentifier:
        'No se puede eliminar usuario.Falta el identificador del usuario',
      deleteErrorUserNotFound: 'Usuario no encontrado',
      deleteErrorUser:
        'Error al eliminar el usuario. Si el usuario aparece como Pendiente esta acción no es posible. Está pendiente de verificación',
      deleteForbidden: 'No tienes permiso para borrar a este usuario',
      deleteConflict:
        'El usuario está registrado como creador de una organización. Por favor asigna otro creador a esa organización antes de borrarlo',
      deleteSuccess: 'Usuario eliminado correctamente',
      details: 'Detalles',
      dividerAddress: 'Dirección',
      dividerAdmin: 'Datos del administrador',
      dividerClinic: 'Datos de la organización',
      dividerDevice: 'Datos del dispositivo (opcional)',
      doAdmin: 'Hacer administrador',
      doAdminConfirm: '¿Está seguro que desea hacer administrador al usuario?',
      doAdminConfirmTitle: 'Confirmación de administrador',
      doAdminError: 'Error al hacer administrador',
      doAdminSuccess: 'Usuario hecho administrador correctamente',
      removeAdmin: 'Quitar administrador',
      removeAdminConfirm:
        '¿Está seguro que desea quitar el permiso de administrador?',
      removeAdminConfirmTitle: 'Confirmación de eliminación de administrador',
      removeAdminError: 'Error al quitar el permiso de administrador',
      removeAdminSuccess: 'Permiso de administrador eliminado correctamente',
      edit: {
        edit: 'Editar',
        title: 'Editar usuario',
      },
      email: 'Email',
      email_administrator_clinic_invalid: 'Email inválido',
      email_administrator_clinic_required: 'Email es requerido',
      messages: {
        delete: 'Usuario eliminado',
        deleteConfirm: '¿Está seguro que desea eliminar el usuario?',
        deleteConfirmTitle: 'Confirmación de eliminación',
        deleteError: 'Error al eliminar el usuario',
        deleteSuccess: 'Usuario eliminado correctamente',
      },
      name: 'Nombre administrador',
      nameOrganization: 'Nombre de la organización',
      name_administrator_clinic_required: 'Nombre es requerido',
      name_organization_required: 'Nombre de la clínica es requerido',
      nationality: 'Nacionalidad',
      nationality_required: 'Nacionalidad es requerida',
      password: 'Contraseña',
      password_administrator_clinic_required: 'Contraseña es requerida',
      phone: 'Teléfono',
      phone_administrator_clinic_required: 'Teléfono es requerido',
      postalCode: 'Código postal',
      postal_code_required: 'Código postal es requerido',
      selectCountry: 'Seleccione país',
      state: 'Provincia',
      state_required: 'Provincia es requerida',
      streetName: 'Direccion',
      streetNumber: 'Número',
      street_name_required: 'Direccion es requerida',
      street_number_required: 'Número es requerido',
      surnames: 'Apellidos administrador',
      surnames_administrator_clinic_required: 'Apellidos es requerido',
      table: {
        activate: '¿Está seguro que desea activar al usuario',
        active: 'Activo',
        adminRole: 'Rol de administrador',
        deactivateTitle: 'Desactivar usuario',
        activateTitle: 'Activar usuario',
        desactivate: '¿Está seguro que desea desactivar al usuario?',
        email: 'Email',
        pending: 'Pendiente de verificación',
        filters: {
          active: 'Activo...',
          email: 'Email...',
          institution: 'Organización...',
          lastName: 'Apellidos...',
          name: 'Nombre...',
          role: 'Rol',
          apply: 'Aplicar'
        },
        institution: 'Organización',
        lastName: 'Apellidos',
        name: 'Nombre',
        particular: 'Particular',
        professional: 'Profesional',
        type: 'Tipo',
        usersActive: 'Usuarios activos',
        usersInactive: 'Usuarios inactivos',
        usersUnverified: 'Usuarios sin verificar'
      },
      title: 'Listado usuarios',
      type: 'Tipo de usuario',
      cannotRemoveOwnAdmin: 'No puedes quitarte el rol de administrador',
      cannotDeleteSelf: 'No puedes eliminar tu propia cuenta'
    },
    requestDeleteAccount: {
      title: 'SOLICITUD DE BORRADO DE DATOS',
      detailsText1:
        'En esta página se indica cómo realizar una solicitud para el borrado de cuentas o datos de carácter personal para usuarios existentes de la aplicación',
      detailsText2: ' desarrollada por ',
      additionalInformationText1:
        'Para cualquier información adicional, puede consultar ',
      additionalInformationText2: ' o mandar un correo de asistencia a ',
      procedure: {
        title: 'PROCEDIMIENTO',
        step1Text1: 'Para proceder a la solicitud debe enviar un correo a',
        step1Text2: 'indicando qué datos desea borrar',
        step2Text1:
          'Nuestro equipo revisará su solicitud y le responderá en un plazo máximo de',
        step2Text2: '30 días hábiles',
        warning:
          'Debe asegurarse de que los datos que desea borrar están ligados al correo utilizado para enviar la solicitud. En caso contrario, la solicitud será denegada.',
      },
    },
    main_panel: {
      created_by: 'Creador',
      patients: 'Pacientes',
      devices: 'Dispositivos',
      device: 'Dispositivo',
      role: 'Rol',
      no_devices: 'Sin dispositivos',
      users: 'Usuarios',
      no_users: 'Sin usuarios',
      filter_device: 'Filtrar por dispositivo',
      filter_role: 'Filtrar por rol',
      expand_all: 'Expandir todo',
      collapse: 'Colapsar todo',
      reset_view: 'Reiniciar la vista',
      show_creators: 'Ver creadores',
      show_role_groups: 'Ver agrupación por roles',
      filter_organization: 'Ir a la organización',
      filter_user: 'Ir al usuario',
      col_view: 'Opciones de visualización',
      col_filters: 'Opciones de filtrado',
      col_navigate: 'Opciones de navegación',
      admins: 'Administradores',
      regular_users: 'Activos',
      inactive_users: 'Inactivos',
      view_device: 'Ver dispositivo',
      view_organization: 'Ver organización',
      filter: 'Filtrar datos',
      by_device: 'Filtrar por dispositivo',
      by_organization: 'Filtrar por organización',
      search: 'Buscar',
      clear: 'Limpiar',
      organizations: 'Organizaciones',
      no_devices_found: 'No hay dispositivos',
      no_organizations_found: 'No hay organizaciones',
    },
  },
  roles: {
    clinic: 'Clinico',
    commercial: 'Comercial',
    maintenance: 'Mantenimiento',
    marsi: 'Admin Marsi',
    personal: 'Personal',
    tester: 'Tester',
    distributor: 'Distribuidor',
    specialist_clinic: 'Especialista clínico',
    all_roles: 'Todos los roles',
  },
  status: {
    active: 'Activo',
    paused: 'Pausado',
  },
  save: 'Guardar',
  cancel: 'Cancelar',
  selectDate: 'Selecciona una fecha',
  selectDevice: 'Selecciona un dispositivo',
  selectInstitution: 'Rellena con el código de tu organización',
  selectOneDevice:
    'Por favor, selecciona un dispositivo de la lista para ver sus datos...',
  selectTimezone: 'Selecciona una zona horaria',
  sessionLastMonth: 'Sesiones del último mes',
  steps: 'pasos',
  timeOfUse: 'Tiempo de uso',
  verifyEmail: 'Por favor, introduce tu email para verificar tu cuenta',
  yes: 'Sí',
  totalPatients: 'Total pacientes de tu organización',
  totalSessions: 'Total de sesiones',
  totalStepsOfMode: 'Total de pasos por modo',
  monthlyEvolution: 'Evolución mensual',
  stepsPerMonth1: 'Pasos por mes: ',
  stepsPerMonth2:
    ' (Tendencia de actividad física del paciente a largo plazo) .',
  serverErrorTitle: 'Error del servidor',
  serverErrorDescription:
    'Error del servidor, por favor intente nuevamente más tarde',
  loadingRanking: 'Cargando ranking...',
  loadingDataPleaseWait:
    'Estamos obteniendo los datos del dispositivo seleccionado.',
  couldNotLoadRanking: 'No se pudo cargar el ranking',
  errorLoadingData: 'Ha ocurrido un problema al obtener los datos.',
  lastMonth: 'Último mes',
  lastTrimester: 'Último trimestre',
  lastSemester: 'Último semestre',
  lastYear: 'Último año',
  noRankingDataAllDevicesTitle: 'Aún no hay datos para mostrar',
  noRankingDataAllDevicesDescription:
    'No se han encontrado pasos registrados durante el último mes en los dispositivos disponibles.',
  noRankingDataDeviceTitle: 'Este dispositivo no tiene actividad reciente',
  noRankingDataDeviceDescription:
    'No se han encontrado pasos registrados durante el último mes para el dispositivo {{device}}.',
  common: {
    success: 'Éxito',
    error: 'Error',
    validation: 'Validación',
    cancel: 'Cancelar',
    clear: 'Limpiar',
    name: 'Nombre',
    color: 'Color',
    description: 'Descripción',
    stats: 'Estadísticas',
    actions: 'Acciones',
    selected: 'Seleccionada',
    access_denied: 'Acceso denegado',
    no_permission: 'No tienes permisos para acceder a esta funcionalidad.',
    videos: 'Videos de formaciones',
    total_videos: 'Total videos: {{total}}',
    error_loading_videos: 'Error al cargar videos',
    no_videos: 'No hay vídeos disponibles todavía',
    default_video_title: 'Video formación ({{number}})',
    play_video: 'Reproducir {{title}}',
    video_name: 'Video: {{name}}',
    tag_label: 'Etiqueta:',
    edit_tags: 'Editar etiquetas',
    add_tag: 'Añadir etiqueta',
    add_tag_subscription: 'Añadir etiqueta / Suscripción',
    tags_management: 'Gestión de etiquetas',
    tag_data: 'Crear etiqueta',
    edit_tag: 'Editar etiqueta',
    tag_name: 'Nombre de la etiqueta',
    tag_name_placeholder: 'App, Marsinet, etc.',
    tag_description_placeholder: 'Ingrese la descripción de la etiqueta',
    subscribed_organizations: 'Organizaciones suscritas',
    organizations_selected_count:
      '{{selected}} organización(es) seleccionada(s)',
    save_tag: 'Guardar etiqueta',
    update_tag: 'Actualizar etiqueta',
    existing_tags: 'Etiquetas existentes ({{total}})',
    no_tags_created: 'Todavía no hay etiquetas creadas',
    tag_name_required: 'El nombre de la etiqueta es obligatorio',
    tag_description_required: 'La descripción es obligatoria',
    tag_created: 'Etiqueta "{{name}}" creada correctamente',
    tag_updated: 'Etiqueta actualizada correctamente',
    tag_deleted: 'Etiqueta "{{name}}" eliminada correctamente',
    error_loading_tags: 'Error al cargar las etiquetas',
    error_creating_tag: 'Error al crear la etiqueta',
    error_updating_tag: 'Error al actualizar la etiqueta',
    error_deleting_tag: 'Error al eliminar la etiqueta',
    confirm_delete: 'Confirmar eliminación',
    confirm_delete_tag:
      '¿Seguro que quieres eliminar la etiqueta "{{name}}"? También se eliminará de {{videos}} vídeo(s) y se dará de baja a {{organizations}} organización(es). Esta acción no se puede deshacer.',
    videos_count_label: 'Videos:',
    organizations_count_label: 'Orgs:',
    subscriptions_management: 'Gestión de suscripciones',
    subscriptions_help:
      'Selecciona las organizaciones y las etiquetas a las que quieras suscribirlas. Los vídeos con estas etiquetas estarán automáticamente disponibles para los usuarios de esas organizaciones.',
    organizations_count: 'Organizaciones ({{total}})',
    no_organizations_available: 'No hay organizaciones disponibles.',
    select_organizations: 'Seleccione organizaciones...',
    select_organizations_to_subscribe:
      'Selecciona organizaciones para suscribirte',
    selected_organizations: 'Organizaciones seleccionadas',
    tags_count: 'Etiquetas ({{total}})',
    no_tags_available_yet: 'No hay etiquetas disponibles todavía.',
    select_tags_to_subscribe: 'Selecciona etiquetas para suscribirte',
    selected_tags: 'Etiquetas seleccionadas',
    subscribe_organizations: 'Suscribir organizaciones',
    select_at_least_one_organization: 'Selecciona al menos una organización',
    select_at_least_one_tag: 'Selecciona al menos una etiqueta',
    organizations_subscribed:
      '{{organizations}} organización(es) suscrita(s) a {{tags}} etiqueta(s) correctamente',
    error_updating_subscriptions: 'Error actualizando suscripciones',
    error_loading_organizations: 'Error al cargar organizaciones',
    no_permission_manage_tags:
      'No tienes permisos para gestionar las suscripciones de etiquetas',
    video_tags: 'Etiquetas del video',
    edit_video_tags_title: 'Edición de etiquetas de los videos',
    edit_video_tags_help:
      'Selecciona las etiquetas que deseas asociar a este video. Puedes seleccionar múltiples etiquetas de la lista disponible. Si no seleccionas ninguna etiqueta, el video no tendrá etiquetas asociadas.',
    select_tags_for_video_help:
      'Selecciona las etiquetas que quieres asignar a este video',
    available_tags: 'Etiquetas disponibles ({{total}})',
    no_tags_available:
      'No hay etiquetas disponibles. Crea algunas etiquetas primero.',
    select_tags_for_video: 'Selecciona etiquetas para este video',
    tags_selected_count: '{{selected}} etiqueta(s) seleccionada(s)',
    no_tags_selected:
      'No se seleccionaron etiquetas. Este video no tendrá etiquetas.',
    save_tags: 'Guardar etiquetas',
    video_tags_updated: 'Etiquetas actualizadas correctamente para este video',
    video_tags_removed: 'Etiquetas eliminadas correctamente para este video',
    error_updating_video_tags:
      'Error al actualizar las etiquetas de este video',
  },
  errors: {
    userNotFound: 'Usuario no encontrado.',
    userNotInAllowedOrg: 'No perteneces a ninguna organización permitida.',
    adminNotFound: 'No se encontró un usuario admin para esta organización.',
    errorRemovingAdminRole: 'Error al eliminar el rol de admin del usuario.',
    cannotRemoveLastAdmin:
      'No se puede borrar al último administrador de la organización.',
    unknown: 'Se ha producido un error inesperado',
  },
  view_details: 'Ver detalles',
  controlErrors: {
    UNKNOWN_ERROR: 'Ha ocurrido un error desconocido.',
    VALIDATION_ERROR: 'Los datos proporcionados no son válidos.',
    UNAUTHORIZED: 'Debes iniciar sesión para realizar esta operación.',
    FORBIDDEN: 'No tienes permisos para realizar esta operación.',
    NOT_FOUND: 'No se ha encontrado el recurso solicitado.',
    CONFLICT: 'La operación no puede completarse debido a un conflicto.',
    AUTH_TOKEN_INVALID: 'El token de autenticación no es válido.',
    AUTH_TOKEN_EXPIRED: 'Tu sesión ha caducado. Inicia sesión de nuevo.',
    AUTHENTICATION_FAILED:
      'No se ha podido completar la autenticación. Comprueba tus credenciales.',
    AUTH_INSUFFICIENT_PERMISSIONS:
      'No tienes permisos suficientes para realizar esta operación.',
    AUTH_CURRENT_PASSWORD_INCORRECT: 'La contraseña actual no es correcta.',
    AUTH_PENDING_EMAIL_VERIFICATION: 'Debes verificar tu correo electrónico antes de iniciar sesión.',
    AUTH_PENDING_ADMIN_ACTIVATION: 'Tu cuenta está pendiente de activación por parte de un administrador.',
    AUTH_TOKEN_WRONG_TYPE: 'El token de autenticación proporcionado no es del tipo esperado.',
    LOGIN_ATTEMPTS_EXCEEDED: 'Has superado el número máximo de intentos de inicio de sesión.',
    LOGIN_COOLDOWN_REQUIRED: 'Debes esperar antes de volver a intentar iniciar sesión.',
    LOGIN_IP_BLOCKED: 'El inicio de sesión está bloqueado temporalmente para esta dirección IP.',
    LOGIN_PERMANENT_BLOCK_REQUIRED: 'La cuenta ha sido bloqueada debido a demasiados intentos fallidos de inicio de sesión.',
    VALIDATION_REQUIRED_FIELD: 'Tienes campos obligatorios por completar.',
    VALIDATION_EMPTY_FIELD: 'Este campo no puede estar vacío.',
    VALIDATION_INVALID_FORMAT: 'El formato introducido no es válido.',
    VALIDATION_INVALID_FORMAT_NUMBER:
      'El valor debe incluir al menos un número.',
    VALIDATION_BIRTH_DATE_INVALID: 'La fecha de nacimiento no es válida.',
    VALIDATION_BIRTH_DATE_UNDERAGE:
      'La fecha de nacimiento no cumple la edad mínima requerida.',
    VALIDATION_INVALID_ORGANIZATION:
      'La organización seleccionada no es válida.',
    VALIDATION_DUPLICATE_VALUE: 'Este valor ya está registrado.',
    VALIDATION_INVALID_FORMAT_LOWERCASE:
      'El valor debe incluir al menos una letra minúscula.',
    VALIDATION_INVALID_FORMAT_UPPERCASE:
      'El valor debe incluir al menos una letra mayúscula.',
    VALIDATION_PASSWORD_MISMATCH: 'Las contraseñas no coinciden.',
    VALIDATION_PASSWORD_REUSED:
      'La nueva contraseña debe ser distinta de la actual.',
    VALIDATION_RESET_TOKEN_INVALID:
      'Token inválido o caducado. Por favor, solicita un nuevo enlace de restablecimiento de contraseña.',
    VALIDATION_OTT_EXPIRED: 'OTT inválido o ha expirado.',
    //Ingestion related errors
    VALIDATION_ACCESS_DENIED: 'No tienes permiso para acceder a este recurso. No encontrado.',
    VALIDATION_MALFORMED: 'El archivo está malformado.',
    VALIDATION_MODEL_NOTFOUND: 'No se ha encontrado el modelo especificado.',
    VALIDATION_INVALID_TYPE: 'El tipo especificado no es válido.',
    VALIDATION_ERROR_PROCESSING: 'Se ha producido un error al procesar la ingesta Zip.',
    VALIDATION_BAD_REQUEST: 'La solicitud no es válida.',
    VALIDATION_PAYLOAD_TOO_LARGE: 'La carga útil es demasiado grande.',
    VALIDATION_UNSUPPORTED_MEDIA_TYPE: 'El tipo de medio no es compatible.',
    SYNC_PATIENT_VERSION_TOO_LOW: 'La versión del paciente es demasiado baja.',
    SYNC_ERROR_DELETING_PATIENT: 'Se ha producido un error al eliminar el paciente.',
    SYNC_NOT_IN_ORG: 'El paciente no está en tu organización.',
    BUSINESS_ERROR_DELETING_PATIENT: 'Se ha producido un error al eliminar el paciente.',
    BUSINESS_USER_NOT_FOUND: 'No se ha encontrado el usuario.',
    BUSINESS_DEVICE_NOT_FOUND: 'No se ha encontrado el dispositivo.',
    BUSINESS_INGESTION_NOT_FOUND: 'No se ha encontrado la ingesta.',
    BUSINESS_MAINTENANCE_ORDER_NOT_FOUND: 'No se ha encontrado la orden de mantenimiento.',
    BUSINESS_UNAUTHORIZED_ADMIN_UPDATE_ORGANIZATION: 'No tienes permisos para modificar la organización asignada a este administrador.',
    BUSINESS_ERROR_UPDATING_ORGANIZATION: 'Se ha producido un error al actualizar la organización.',
    BUSINESS_DEVICE_NOT_FOUND_IN_ORGANIZATION: 'No se ha encontrado el dispositivo en la organización.',
    BUSINESS_ORGANIZATION_NOT_FOUND: 'No se ha encontrado la organización.',
    BUSINESS_DEVICE_ALREADY_ASSIGNED_TO_ORGANIZATION:
      'El dispositivo ya está asignado a una organización.',
    BUSINESS_DEVICE_NOT_LINKED_TO_ORGANIZATION:
      'El dispositivo no está vinculado a la organización.',
    BUSINESS_DEVICE_MODEL_NOT_FOUND:
      'No se ha encontrado el modelo del dispositivo.',
    BUSINESS_CONFLICT_ON_DELETE_USER:
      'No se puede eliminar el usuario porque tiene información o relaciones asociadas.',
    BUSINESS_DEVICE_SERIAL_EXISTS:
      'Ya existe un dispositivo con este número de serie.',
    BUSINESS_CONFLICT_ON_DELETE_DEVICE:
      'No se puede eliminar el dispositivo porque tiene datos asociados.',
    BUSINESS_USER_ALREADY_ACTIVE: 'El usuario ya está activo.',
    BUSINESS_ADMIN_NOT_FOUND_FOR_ORGANIZATION: 'No se ha encontrado un administrador para la organización.',
    BUSINESS_CANNOT_REMOVE_LAST_ADMIN: 'No se puede eliminar al último administrador de la organización.',
    BUSINESS_ERROR_REMOVING_ADMIN_ROLE: 'Se ha producido un error al eliminar el rol de administrador.',
    BUSINESS_USER_NOT_IN_ALLOWED_ORG: 'El usuario no pertenece a ninguna organización permitida.',
    BUSINESS_INVALID_CREATOR: 'No es posible designar a ese usuario como creador de esta organización.',
    BUSINESS_CONFLICT_ON_DELETE_ORGANIZATION: 'No se puede eliminar la organización porque hay registros dependientes en proceso de importación.',
    BUSINESS_NOT_CONFIG_PRIVACY_SETTINGS: 'La configuración de privacidad no está correctamente configurada.',
    BUSINESS_ERROR_PRIVACY_SETTINGS: 'Se ha producido un error al actualizar la configuración de privacidad.',
    BUSINESS_USER_ALREADY_ADMIN: 'El usuario ya es administrador.',
    BUSINESS_ONLY_MARSI: 'Solo el rol marsi puede realizar esta acción.',
    BUSINESS_SESSION_NOT_FOUND: 'No se ha encontrado la sesión.',
    VALIDATION_INVALID_FIELDS: 'Los campos proporcionados no son válidos.',
    EXTERNAL_API_ERROR: 'Se ha producido un error al comunicarse con un servicio externo.',
    EXTERNAL_API_TIMEOUT: 'El servicio externo ha tardado demasiado en responder.',
    DATABASE_CONNECTION_ERROR: 'No se ha podido establecer la conexión con la base de datos.',
    NETWORK_TIMEOUT: 'La solicitud ha superado el tiempo de espera.',
    NETWORK_ERROR:
      'Se ha producido un error de red. Comprueba tu conexión e inténtalo de nuevo.',
    SYSTEM_INTERNAL_ERROR: 'Se ha producido un error interno del sistema.',
    SYNC_PATIENTS_UPLOAD_FAILED: 'No se han podido sincronizar los pacientes locales con el servidor.',
    SYNC_PATIENTS_DOWNLOAD_FAILED: 'No se han podido descargar los pacientes del servidor.',
    SYNC_DEVICES_DOWNLOAD_FAILED: 'No se han podido descargar los dispositivos del servidor.',
    SYNC_SESSIONS_UPLOAD_FAILED: 'No se han podido subir las sesiones pendientes.',
    BUSINESS_DASHBOARD_ALREADY_EXISTS: 'Ya existe un panel con el mismo nombre en la organización.',
    BUSINESS_CONFLICT_ON_DELETE_DASHBOARD: 'No se puede eliminar el panel porque hay registros dependientes.',
    BUSINESS_DASHBOARD_NOT_FOUND: 'No se ha encontrado el panel.',
    BUSINESS_PATIENT_NOT_FOUND: 'No se ha encontrado el paciente.',
    //RPS
    RPS_UNAVAILABLE: 'RPS no está disponible temporalmente. Inténtalo de nuevo más tarde.',
    RPS_ERROR: 'Se ha producido un error al comunicarse con RPS.',
    RPS_COMPONENT_OUT_OF_SERVICE: 'El componente está fuera de servicio y no permite realizar esta operación.',
    RPS_EMAIL_NOT_FOUND: 'No se ha encontrado usuario con este correo electrónico',
    RPS_NOT_COMPONENT: 'No se ha encontrado un componente para el número de serie ${serial}',
    RPS_NOT_FOUND: 'No se ha encontrado el incidencia solicitado.',
    RPS_NOT_CLOSED: 'No se puede cerrar la incidencia: tiene orden(es) de mantenimiento sin finalizar)',
    RPS_IDENTIFIER_REQUIRED: 'Se requiere un identificador.',
    RPS_FIELDS_INVALID: 'Datos no válidos',
    RPS_NOT_COMPONENT_ASSOCIATED: 'La incidencia/ OM no tiene ningún componente asociado.',
    RPS_OTHER_TEAM: 'La incidencia pertenece a otro equipo y no se puede procesar.',
    RPS_INVALID_OM_CLOSED: 'No se puede cerrar la orden de mantenimiento: La orden de mantenimiento ya está cerrada y no admite cambios de estado.',
    RPS_OM_CANT_CLOSED: 'Para finalizar la orden hay que usar el cierre, no el cambio de estado',
    RPS_OM_NOT_STATUS: 'La orden de mantenimiento no está en el estado requerido para esta operación.',
    //OTA
    BUSINESS_OTA_BAD_REQUEST: 'Ha fallado la comprobación de la integridad del archivo. La suma de comprobación no coincide. Es posible que el archivo se haya dañado durante la subida.',
    BUSINESS_OTA_NOT_VALID: 'Tipo de software no válido. Valores válidos: 0 (CM7), 1 (CM4), 2 (ESP)',
    BUSINESS_OTA_UPLOAD_FAILED: 'La subida del firmware ha fallado debido a un error interno del servidor.',
    BUSINESS_OTA_METADATA_INVALID: 'Metadatos del firmware no válidos',
    BUSINESS_OTA_NAME_INVALID: 'Nombre del firmware no válido',
    BUSINESS_OTA_EXISTS_VERSION: 'La versión ya existe para el tipo de software. Por favor, utiliza una versión diferente.',
    BUSINESS_OTA_NEW_VERSION: 'Se ha detectado una nueva versión del firmware. Por favor, actualiza a la última versión.',
    BUSINESS_OTA_NOT_FOUND: 'No se ha encontrado el firmware solicitado.',
    BUSINESS_OTA_RANGE_INVALID: 'El rango de descarga del firmware no es válido.',
    //SURVEYS
    BUSINESS_NOT_FOUND: 'No se han encontrado los datos solicitados',
    BUSINESS_USER_NOT_SUBSCRIBED: 'El usuario no está suscrito a la encuesta solicitada.',
    RPS_USER_NOT_FOUND: 'No existe un usuario en RPS asociado a este email',
    RPS_EMPLOYEE_NOT_FOUND: 'No existe un empleado en RPS asociado a este email',
    RPS_COMPONENT_NOT_FOUND: 'No se ha encontrado el componente en RPS.',
    RPS_USER_REQUIRED_CODE: 'El código de usuario es obligatorio.',
    RPS_INCIDENCE_NOT_FOUND: 'No se encontró la incidencia con el identificador',
    RPS_OM_NOT_MATCH: 'La orden de mantenimiento no no está asociada a la incidencia.',
    RPS_SOLUTION_NOT_FOUND: 'RPS no devolvió el código de la incidencia o de la orden de mantenimiento',
  },
};
export default es;
